/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import { getLookupPiyasalar, getLookupParaBirimleri } from "./apiCache";

const C={bg:"#0f172a",panel:"#1e293b",border:"#334155",text:"#e2e8f0",muted:"#94a3b8",accent:"#3b82f6",gold:"#eab308",teal:"#0d9488",bullish:"#16a34a"};

const PERIYOT_MAP = {"1 Gün":"1d","1 Hafta":"1wk","1 Ay":"1mo","3 Aylık":"3mo","6 Aylık":"6mo","Yıllık":"1y"};
const TOLERANS_MAP = { "%1": 0.01, "%3": 0.03, "%5": 0.05 };
const DIP_PERIYOT_MAP = { "1 Ay": "ay", "3 Aylık": "ceyrek", "6 Aylık": "yari", "Yıllık": "yil" };
const DIP_PERIYOT_OPTS = ["1 Ay", "3 Aylık", "6 Aylık", "Yıllık"];
const PERIYOT_OPTS = ["1 Gün", "1 Hafta", "1 Ay", "3 Aylık", "6 Aylık", "Yıllık"];
const KZ_LISTESI = ["Asya KZ (03:00-09:00)","Londra Açılış (10:00-12:00)","New York Açılış (15:00-17:00)","Londra Kapanış (18:00-20:00)","BIST Açılış (10:00-11:00)","BIST Öğle Dönüşü (13:00-14:00)","BIST Kapanış Öncesi (17:00-18:00)"];

function BilgiIkonu({ alan }) {
    const [acik, setAcik] = React.useState(false);
    const BILGI = {
        "tolerans": {
            baslik: "Tolerans",
            icerik: "Anlık fiyatın tarihsel dip seviyesine ne kadar yakın olabileceğini belirler.\n• %1: Fiyat dip seviyesinin en fazla %1 üzerinde olan hisseler\n• %3: Dip seviyesinin en fazla %3 üzerinde (varsayılan)\n• %5: Daha geniş bant — dipten biraz yükselmiş hisseler de dahil",
        },
        "lookback": {
            baslik: "Lookback (Geriye Bakış)",
            icerik: "Likidite taramasında kaç mumluk geçmişe bakılacağını belirler.\n• 50 Mum: Kısa vadeli — son dönemin likidite seviyeleri\n• 60-75 Mum: Orta vadeli — dengeli tarama\n• 100 Mum: Uzun vadeli — köklü destek/direnç seviyelerindeki likidite\nDaha fazla mum = daha az ama daha önemli likidite seviyeleri.",
        },
        "wick_oran": {
            baslik: "Min Fitil Oranı",
            icerik: "Likit sweep sinyali için mumun fitilinin gövdeye minimum oranı.\n• %30: Zayıf sweep — kısa fitil yeterli\n• %50: Standart sweep (varsayılan)\n• %70: Güçlü sweep — fitil gövdenin çok üzerinde\nYüksek fitil oranı = daha güvenilir sweep sinyali.",
        },
        "bpr_kontrol": {
            baslik: "BPR Kontrol (Balanced Price Range)",
            icerik: "iFVG seçildiğinde aktif olur. Tespit edilen iFVG'nin aynı zamanda bir Balanced Price Range (BPR) oluşturup oluşturmadığını kontrol eder.\n• Evet: Sadece BPR oluşturan iFVG'ler gösterilir (daha güçlü sinyal)\n• Hayır: Tüm iFVG'ler gösterilir\nBPR = Boğa FVG + Ayı FVG çakışması → kurumsal denge bölgesi.",
        },
        "tarama_metodu": {
            baslik: "Tarama Metodu",
            icerik: "FVG taramasının hangi hisse evreninde yapılacağını belirler.\n• Dip Altı Hisselerde: Önce 'Dip Periyodu'na göre dip yapan hisseler tespit edilir, ardından bu hisselerde FVG aranır. Daha odaklı ve potansiyel yüksek sonuçlar verir.\n• Tüm Hisselerde: Tüm hisse evreninde FVG aranır. Daha geniş kapsamlı tarama.",
        },
        "dip_periyodu": {
            baslik: "Dip Periyodu",
            icerik: "Tarama Metodu 'Dip Altı Hisselerde' seçildiğinde aktif olur. Hissenin bu periyottaki tarihsel dipinin altında işlem gördüğü durumları filtreler.\n• Aylık: Son 1 ayın dibi altındaki hisseler\n• 3 Aylık: Son 3 ayın dibi altındaki hisseler\n• 6 Aylık: Son 6 ayın dibi altındaki hisseler\n• Yıllık: 52 haftalık dip altındaki hisseler (en güçlü sinyal)",
        },
        "capa_tolerans": {
            baslik: "Tolerans (Çapa Noktası)",
            icerik: "FVG'nin, tarihsel fiyatın altında kalması gereken minimum yüzdelik eşik.\n• %30: Geniş tolerans — daha fazla hisse dahil\n• %50-70: Standart — dengeli\n• %90-100: Çok sıkı — FVG neredeyse tamamen fiyat altında olmalı (en güçlü sinyal)\nYüksek tolerans = daha az ama daha güvenilir çapa noktası.",
        },
                "kz_killzone": {
            baslik: "Killzone",
            icerik: "Likidite sweep ve yapı kırılımlarının en çok gerçekleştiği seans dilimleri.\n• Asya KZ (03:00-09:00): Asya seansı — düşük likidite, sweep tuzakları\n• Londra Açılış (10:00-12:00): Avrupa açılışı — en yüksek likidite\n• New York Açılış (15:00-17:00): ABD açılışı — en volatil dönem\n• Londra Kapanış (18:00-20:00): Pozisyon kapanışları\n• BIST Açılış (10:00-11:00): Borsa İstanbul açılışı\n• BIST Öğle Dönüşü (13:00-14:00): Öğle hacimsiz dönemi\n• BIST Kapanış Öncesi (17:00-18:00): Kapanış öncesi yüksek hacim",
        },
        "kz_yapi_tipi": {
            baslik: "Yapı Tipi",
            icerik: "Killzone içinde aranan fiyat yapısı:\n• FVG: Fair Value Gap — fiyat boşluğu dolumu\n• MSB: Market Structure Break — yapı kırılımı\n• Sweep: Likidite avı — önceki high/low kırılımı\nSadece bir yapı tipi seçilebilir.",
        },
        "kz_geri_bakis": {
            baslik: "Geriye Bakış",
            icerik: "Kaç günlük geçmişe bakılacağını belirler.\n• 3 Gün: Çok taze sinyaller — çok az sonuç\n• 5 Gün: Standart (varsayılan)\n• 7-10 Gün: Daha geniş geçmiş — daha fazla sinyal\nBüyük değer = daha fazla sinyal ama bazıları eskimiş olabilir.",
        },
        "ha_ort_pencere": {
            baslik: "Ortalama Pencere (Lookback)",
            icerik: "Hacim ortalamasının hesaplanacağı gün sayısı.\n• 5 Gün: Kısa vadeli spike tespiti (daha duyarlı)\n• 20 Gün: Standart, orta vadeli (varsayılan)\n• 50 Gün: Uzun vadeli, nadiren tetiklenir\nDaha kısa pencere = daha fazla sinyal ama daha fazla gürültü.",
        },
        "ha_min_spike": {
            baslik: "Minimum Spike Katsayısı",
            icerik: "Hissenin listeye girmesi için son günün hacminin ortalamaya oranı.\n• 1.5×: Normalin 1.5 katı hacim (varsayılan)\n• 2.0×: Belirgin spike\n• 3.0×: Anormal, güçlü kurumsal ilgi\nDüşük eşik → çok sinyal; yüksek eşik → az ama güçlü sinyal.",
        },
        "ha_sinyal_tipi": {
            baslik: "Sinyal Tipi (Hacim + Fiyat + Momentum)",
            icerik: "Üç faktörün birleşimiyle belirlenir:\n• Güçlü: Hacim + fiyat + momentum üçü uyumlu (en güvenilir)\n• Orta: Faktörler kısmen uyumlu, ek teyit önerilir\n• Zayıf: Destekleyici faktörler yetersiz\n• Dikkatli: Fiyat yönü ile momentum ters — dikkat\n• Belirsiz: Fiyat hareketi ±%0.05 içinde",
        },
        "div_pivot_modu": {
            baslik: "Pivot Modu (Swing Tespit Yöntemi)",
            icerik: "Divergence için kullanılan swing High/Low tespit algoritması:\n• Fractal: Her mumun iki yanındaki N muma göre local max/min tespiti. Gürültüye daha az duyarlı.\n• ZigZag: Fiyatın belirlenen eşik kadar (%X) hareket etmesini bekler. Daha az ama daha belirgin pivotlar üretir.",
        },
        "div_osilatorler": {
            baslik: "Osilatörler",
            icerik: "Divergence tespitinde kullanılan teknik göstergeler:\n• RSI: Relative Strength Index — momentum osilatörü\n• MACD Histogram: Trend + momentum birleşimi\n• Stokastik RSI: RSI'nın normalize versiyonu — aşırı alım/satım\n• OBV: On-Balance Volume — hacim bazlı momentum\nBirden fazla osilatör seçilirse 'konfluence skoru' hesaplanır.",
        },
        "div_tipler": {
            baslik: "Divergence Tipleri",
            icerik: "Fiyat ile osilatör arasındaki uyumsuzluk türleri:\n• Regular Bullish: Fiyat LL, osilatör HL → dip dönüşü\n• Regular Bearish: Fiyat HH, osilatör LH → tepe dönüşü\n• Hidden Bullish: Fiyat HL, osilatör LL → boğa devamı\n• Hidden Bearish: Fiyat LH, osilatör HH → ayı devamı",
        },
        "div_swing_pencere": {
            baslik: "Swing Pencere (Fractal)",
            icerik: "Fractal modda pivot tespiti için gereken yan mum sayısı.\n• 2-3: Hassas, çok sayıda küçük pivot\n• 5: Standart (varsayılan)\n• 7-10: Yalnızca büyük swinglar",
        },
        "div_karsilastirilan_pivot": {
            baslik: "Karşılaştırılan Pivot",
            icerik: "Divergence hesabında kaç pivot geriye bakılacağı.\n• 2: Son iki pivot\n• 3: Son 3 pivot — daha geniş tarama",
        },
        "div_min_pivot": {
            baslik: "Min Pivot Mesafe (Mum)",
            icerik: "İki pivot arasındaki minimum mum sayısı.\n• 3: Çok yakın pivotlar dahil\n• 5-10: Anlamlı mesafe gerektirir\nÇok küçük değer false divergence üretebilir.",
        },
        "div_min_hareket": {
            baslik: "Min Hareket (ATR Çarpanı)",
            icerik: "İki pivot arasındaki minimum fiyat hareketi (ATR katı).\n• 0: Filtre yok\n• 0.5-1.0: Anlamlı hareket gerektirir",
        },
        "div_rsi_periyot": {
            baslik: "RSI Periyot",
            icerik: "RSI hesabında kullanılan periyot.\nStandart: 14",
        },
        "div_macd_fast": { baslik: "MACD Fast (Hızlı EMA)", icerik: "Standart: 12" },
        "div_macd_slow": { baslik: "MACD Slow (Yavaş EMA)", icerik: "Standart: 26. Fast'tan büyük olmalı." },
        "div_macd_signal": { baslik: "MACD Signal (Sinyal EMA)", icerik: "Standart: 9. Histogram = MACD − Signal." },
        "div_stoch_rsi_periyot": { baslik: "StochRSI: RSI Periyot", icerik: "Standart: 14" },
        "div_stoch_periyot": { baslik: "StochRSI: Stoch Periyot", icerik: "Standart: 14" },
        "div_stoch_k": { baslik: "StochRSI: %K", icerik: "Standart: 3" },
        "div_stoch_d": { baslik: "StochRSI: %D", icerik: "Standart: 3. %K'nın hareketli ortalaması." },
        "hp_sinyal_filtresi": {
            baslik: "Sinyal Filtresi (Hacim Profili)",
            icerik: "Taramaya dahil edilecek sinyalleri filtreler:\n• POC Yakını: Fiyat, POC seviyesine %2 içinde\n• Discount: Fiyat VAL altında — ucuz bölge\n• Premium: Fiyat VAH üstünde — pahalı bölge\n• HVN Yakın: Yüksek hacim düğümüne %1 içinde\n• LVN İçi: Düşük hacim bölgesinde\nBirden fazla seçilirse OR mantığıyla çalışır.",
        },
        "hp_mum_sayisi": {
            baslik: "Mum Sayısı (Hacim Profili)",
            icerik: "Hacim profilinin hesaplanacağı mum sayısı.\n• 100: Yakın dönem — kısa vadeli profil\n• 200-300: Orta dönem — standart\n• 500: Uzun dönem — köklü destek/direnç seviyeleri\nDaha fazla mum = daha güvenilir profil ama daha yavaş tarama.",
        },
        "swing_penceresi": {
            baslik: "Swing Penceresi",
            icerik: "Swing High/Low tespiti için her iki yanda kontrol edilecek mum sayısı.\n• 2-3 Mum: Hassas, çok pivot üretir — kısa vadeli\n• 5 Mum: Standart, dengeli (varsayılan)\n• 7-8 Mum: Sadece büyük dönüşler — uzun vadeli\nDaha büyük pencere = daha az ama daha güvenilir swing.",
        },
        "ote_mum_sayisi": {
            baslik: "Mum Sayısı (OTE Lookback)",
            icerik: "OTE hesabında kaç mumluk geçmişe bakılacağı.\n• 50: Yakın dönem\n• 100-150: Standart\n• 200-300: Uzun vadeli OTE bölgeleri",
        },
        "obbb_mum_sayisi": {
            baslik: "Mum Sayısı (OB/BB Lookback)",
            icerik: "Order Block ve Breaker Block tespitinde kullanılan lookback periyodu.\n• 100-200: Yakın ve orta vadeli OB'ler\n• 300-500: Uzun vadeli, köklü OB/BB seviyeleri\nDaha fazla mum = daha eski ama kurumsal açıdan önemli seviyeler.",
        },
        "govde_oran": {
            baslik: "Min Gövde Oranı",
            icerik: "Order Block mumunun gövdesi (açılış-kapanış farkı) / toplam boy oranı.\n• %40: Orta gövde — standart\n• %60-70: Güçlü gövde — daha güvenilir OB\nDüşük gövde oranı gürültülü mum demektir, OB güvenilirliği azalır.",
        },
        "sadece_taze": {
            baslik: "Sadece Taze OB/BB",
            icerik: "Fiyatın henüz test etmediği (dokunmadığı) Order Block ve Breaker Block'ları gösterir.\n• Açık: Sadece taze (test edilmemiş) OB/BB'ler\n• Kapalı: Tüm OB/BB'ler (test edilmiş dahil)\nTaze OB'ler daha yüksek tepki olasılığına sahiptir.",
        },
        "idm_mum_sayisi": {
            baslik: "Mum Sayısı (IDM Lookback)",
            icerik: "IDM (Inducement) tespitinde kullanılan lookback periyodu.\n• 100-150: Yakın ve orta vadeli IDM'ler\n• 200-300: Uzun vadeli inducement seviyeleri",
        },
        "range_penceresi": {
            baslik: "Range Penceresi (P/D Zone)",
            icerik: "Premium/Discount Zone hesabında kullanılan swing high/low tespit penceresi.\n• 10 Mum: Kısa vadeli P/D seviyeleri\n• 20-50 Mum: Standart\n• 100 Mum: Uzun vadeli, büyük P/D bölgeleri\nBüyük pencere = daha az ama daha önemli P/D bölgesi.",
        },
        "pd_mum_sayisi": {
            baslik: "Mum Sayısı (P/D Lookback)",
            icerik: "P/D Zone tespitinde geriye bakılan mum sayısı.\n• 100-300: Yakın ve orta vadeli\n• 500: Uzun vadeli P/D bölgeleri",
        },
        "smt_swing": {
            baslik: "Swing Penceresi (SMT)",
            icerik: "SMT divergence tespitinde kullanılan pivot swing penceresi.\n• 2 Mum: Çok hassas, sık pivot\n• 3 Mum: Standart\n• 5 Mum: Yalnızca büyük pivotlar",
        },
        "smt_korelasyon": {
            baslik: "Min Korelasyon",
            icerik: "İki varlık arasındaki minimum korelasyon skoru.\n• %50-60: Zayıf korelasyon — daha fazla sinyal\n• %70-80: Standart — güvenilir uyumsuzluk tespiti\n• %90: Çok güçlü korelasyon — nadiren tetiklenir ama çok güvenilir",
        },
        "smt_mum_sayisi": {
            baslik: "Mum Sayısı (SMT Lookback)",
            icerik: "SMT divergence tespitinde geriye bakılan mum sayısı.\n• 100: Yakın vadeli SMT\n• 200-300: Standart",
        },
        "fvg_mum_sayisi": {
            baslik: "Mum Sayısı (Lookback)",
            icerik: "FVG tespitinde kaç mumluk geçmişe bakılacağı.\n• 25-50: Yakın dönem, hızlı FVG tespiti\n• 100-200: Standart — dengeli\n• 300-500: Uzun vadeli FVG'ler\n• 600-700: En eski ve köklü FVG seviyeleri\nDaha fazla mum = daha uzun vadeli FVG'ler ama daha yavaş tarama.",
        },
    };
    const bilgi = BILGI[alan];
    if (!bilgi) return null;
    return (
        <span style={{position:"relative",display:"inline-flex",alignItems:"center",marginLeft:4}}>
            <span onMouseEnter={()=>setAcik(true)} onMouseLeave={()=>setAcik(false)}
                style={{cursor:"help",color:C.muted,fontSize:11,border:`1px solid ${C.border}`,borderRadius:"50%",width:14,height:14,display:"inline-flex",alignItems:"center",justifyContent:"center",fontWeight:700,lineHeight:1}}>i</span>
            {acik&&(<div style={{position:"absolute",top:"calc(100% + 6px)",left:"50%",transform:"translateX(-50%)",zIndex:500,background:"#1e293b",border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",width:250,boxShadow:"0 8px 24px rgba(0,0,0,0.5)",pointerEvents:"none"}}>
                <div style={{fontSize:12,fontWeight:700,color:C.accent,marginBottom:6}}>{bilgi.baslik}</div>
                <div style={{fontSize:11,color:C.muted,lineHeight:1.6,whiteSpace:"pre-line"}}>{bilgi.icerik}</div>
            </div>)}
        </span>
    );
}

// ─── Modül listesi ────────────────────────────────────────────
const MODULLER = [
    "Dip Tarama",
    "Likidite Tarama",
    "FVG Tarama",
    "Çapa Noktası Tarama",
    "MSB Tarama",
    "OTE Tarama",
    "OB & BB Tarama",
    "IDM Tarama",
    "P/D Zone Tarama",
    "SMT Tarama",
    "Killzone Tarama",
    "Topdown Cascade",
    "Hacim Profili Tarama",
    "Hacim Akışı Tarama",
    "Divergence Tarama",
];


function HareketliBar() {
    const [pos, setPos] = React.useState(0);
    React.useEffect(() => {
        const id = setInterval(() => setPos(p => (p + 2) % 120), 20);
        return () => clearInterval(id);
    }, []);
    return (
        <div style={{height:4,background:"#334155",borderRadius:4,overflow:"hidden",margin:"12px 0"}}>
            <div style={{height:"100%",width:"40%",background:"linear-gradient(90deg,#3b82f6,#06b6d4)",borderRadius:4,transition:"transform 0.02s linear",transform:`translateX(${pos * 1.5}px)`}}/>
        </div>
    );
}

function IlerlemePanel({modul, ilerleme, tamamlanan, toplam, bulunan, baslangic, renk}) {
    const [gecen, setGecen] = React.useState(0);
    React.useEffect(() => {
        if (!baslangic) return;
        const id = setInterval(() => setGecen(Math.floor((Date.now() - baslangic) / 1000)), 1000);
        return () => clearInterval(id);
    }, [baslangic]);
    const fmt = sn => {
        if (!sn || sn <= 0) return "—";
        const h = Math.floor(sn/3600), m = Math.floor((sn%3600)/60), s = sn%60;
        return h > 0
            ? `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`
            : `${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    };
    const kalan = tamamlanan > 0 && gecen > 0 && toplam > 0
        ? Math.round((gecen / tamamlanan) * (toplam - tamamlanan)) : null;
    return (
        <div style={{background:"#1e293b",border:`2px solid ${renk}44`,borderRadius:12,padding:20,boxShadow:`0 0 20px ${renk}18`}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                <span style={{fontSize:20}}>📊</span>
                <span style={{fontSize:15,fontWeight:700,color:"#e2e8f0"}}>{modul} Taranıyor</span>
                <span style={{marginLeft:"auto",fontSize:22,fontWeight:800,color:renk}}>%{ilerleme}</span>
            </div>
            <div style={{height:10,background:"#0f172a",borderRadius:6,overflow:"hidden",marginBottom:12,border:"1px solid #334155"}}>
                <div style={{height:"100%",width:`${ilerleme}%`,background:`linear-gradient(90deg,${renk},#06b6d4)`,borderRadius:6,transition:"width 0.5s ease"}}/>
            </div>
            <div style={{display:"flex",gap:24,flexWrap:"wrap"}}>
                {[
                    ["TAMAMLANAN", toplam>0?`${tamamlanan.toLocaleString("tr-TR")} / ${toplam.toLocaleString("tr-TR")}`:"—", renk],
                    ["BULUNAN", bulunan>0?bulunan.toLocaleString("tr-TR"):"—", "#16a34a"],
                    ["GEÇEN SÜRE", fmt(gecen), "#0d9488"],
                    ["TAHMİNİ KALAN", kalan!=null?fmt(kalan):tamamlanan===0?"Hesaplanıyor...":"—", "#eab308"],
                ].map(([lbl,val,clr])=>(
                    <div key={lbl}><div style={{fontSize:10,color:"#94a3b8",marginBottom:2}}>{lbl}</div><div style={{fontSize:16,fontWeight:700,color:clr}}>{val}</div></div>
                ))}
            </div>
        </div>
    );
}


function IndirMenusu({ veri, setIslemMenuAcik }) {
    const [acik, setAcik] = React.useState(false);
    const dosyaAdi = `coklu_tarama_${new Date().toLocaleDateString("tr-TR").replace(/\./g,"-")}`;
    const indir = async (fmt) => {
        setAcik(false); setIslemMenuAcik(false);
        if (!veri?.length) return;
        if (fmt === "xlsx") {
            const XLSX = await import("xlsx");
            const ws = XLSX.utils.json_to_sheet(veri);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sonuçlar");
            XLSX.writeFile(wb, `${dosyaAdi}.xlsx`);
        } else if (fmt === "csv") {
            const h = Object.keys(veri[0]||{});
            const rows = veri.map(r => h.map(k => { const v=String(r[k]??""); return v.includes(",")||v.includes('"')?`"${v.replace(/"/g,'""')}"`:v; }).join(","));
            const blob = new Blob(["\uFEFF"+[h.join(","),...rows].join("\n")], {type:"text/csv;charset=utf-8;"});
            const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href=url; a.download=`${dosyaAdi}.csv`; a.click(); URL.revokeObjectURL(url);
        } else if (fmt === "pdf") {
        } else if (fmt === "pdf") {
            try {
                const {default:jsPDF} = await import("jspdf");
                const {default:autoTable} = await import("jspdf-autotable");
                const h = Object.keys(veri[0]||{});
                const doc = new jsPDF({orientation:"landscape",unit:"pt",format:"a4"});
                doc.setFontSize(14); doc.text("Çoklu Tarama Sonuçları",20,30);
                autoTable(doc,{head:[h],body:veri.map(r=>h.map(k=>String(r[k]??""))),startY:50,styles:{fontSize:8},headStyles:{fillColor:[29,78,216],textColor:255}});
                doc.save(`${dosyaAdi}.pdf`);
            } catch { }
        } else if (fmt === "svg") {
            const h = Object.keys(veri[0]||{});
            const cw=Math.max(60,Math.floor(740/h.length)),rh=18,hh=24,tw=cw*h.length;
            const pw=Math.max(tw+40,800),ph=80+hh+veri.length*rh;
            const esc=s=>String(s).slice(0,18).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
            const rows=veri.map((r,i)=>`<g transform="translate(20,${60+hh+i*rh})"><rect width="${tw}" height="${rh}" fill="${i%2===0?"#1e293b":"#0f172a"}" stroke="#334155" stroke-width="0.5"/>${h.map((k,j)=>`<text x="${j*cw+4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(r[k])}</text>`).join("")}</g>`).join("");
            const heads=h.map((k,j)=>`<text x="${20+j*cw+4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(k)}</text>`).join("");
            const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${pw}" height="${ph}"><rect width="${pw}" height="${ph}" fill="#0f172a"/><text x="20" y="22" font-size="14" font-weight="bold" fill="#e2e8f0" font-family="Arial">Çoklu Tarama Sonuçları</text><rect x="20" y="52" width="${tw}" height="${hh}" fill="#1d4ed8"/>${heads}${rows}</svg>`;
            const blob=new Blob([svg],{type:"image/svg+xml"});const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;a.download=`${dosyaAdi}.svg`;a.click();URL.revokeObjectURL(url);
        }
    };
    return (
        <div style={{position:"relative"}} onMouseEnter={()=>setAcik(true)} onMouseLeave={()=>setAcik(false)}>
            <button style={{display:"flex",width:"100%",textAlign:"left",justifyContent:"space-between",padding:"10px 16px",border:"none",background:"none",cursor:"pointer",color:"#e2e8f0",fontSize:13,borderBottom:"1px solid #334155"}}>
                📥 İndir <span style={{color:"#94a3b8"}}>▶</span>
            </button>
            {acik && (
                <div style={{position:"absolute",left:"100%",top:0,background:"#1e293b",border:"1px solid #334155",borderRadius:8,boxShadow:"0 8px 24px rgba(0,0,0,0.4)",minWidth:160,overflow:"hidden",zIndex:101}}>
                    {[{l:"Excel (.xlsx)",f:"xlsx"},{l:"CSV (.csv)",f:"csv"},{l:"PDF (.pdf)",f:"pdf"},{l:"SVG (.svg)",f:"svg"}].map(s=>(
                        <button key={s.f} onClick={()=>indir(s.f)} style={{display:"block",width:"100%",textAlign:"left",padding:"9px 14px",border:"none",background:"none",cursor:"pointer",color:"#e2e8f0",fontSize:13,borderBottom:"1px solid #334155"}}>{s.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}


function defaultFiltreler(modul, piyasa) {
    switch (modul) {
        case "Dip Tarama":
            return { periyot: "Yıllık", tolerans: "%3" };
        case "Likidite Tarama":
            return { sweep_tipler: { "Boğa Sweep": true, "Ayı Sweep": false }, tarama_periyot: "1 Gün", lookback: 50, wick_oran: 50 };
        case "FVG Tarama":
            return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false, "iFVG": false }, bpr_kontrol: false, tarama_periyot: "1 Ay", tarama_metodu: "Dip Altı Hisselerde", dip_periyodu: "Yıllık", mum_sayisi: 100 };
        case "Çapa Noktası Tarama":
            return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false }, tolerans: 50 };
        case "MSB Tarama":
            return { msb_tipler: { "Boğa MSB": true, "Ayı MSB": false }, tarama_periyot: "1 Ay", swing_pencere: 3 };
        case "OTE Tarama":
            return { ote_tipler: { "Boğa OTE": true, "Ayı OTE": false }, tarama_periyot: "1 Ay", swing_pencere: 3, mum_sayisi: 100 };
        case "OB & BB Tarama":
            return { obbb_tipler: { "Boğa OB": true, "Ayı OB": false, "Boğa BB": false, "Ayı BB": false }, tarama_periyot: "1 Gün", mum_sayisi: 200, govde_oran: 60, sadece_taze: true };
        case "IDM Tarama":
            return { idm_tipler: { "Boğa IDM": true, "Ayı IDM": false }, tarama_periyot: "1 Gün", mum_sayisi: 200 };
        case "P/D Zone Tarama":
            return { bolge_filtre: { "Deep Discount": true, "Discount": true, "Equilibrium": false, "Premium": false, "Extreme Premium": false }, tarama_periyot: "1 Gün", range_window: 20, mum_sayisi: 200 };
        case "SMT Tarama":
            return { smt_tipler: { "Boğa SMT": true, "Ayı SMT": false }, tarama_periyot: "1 Gün", referans_varlik: piyasa === "BIST" ? "XU100 (BIST100)" : "BTC", swing_pencere: 3, kor_pencere: 50, min_korelasyon: 70, mum_sayisi: 200 };
        case "Killzone Tarama":
            return { killzoneler: { "Londra Açılış (10:00-12:00)": true }, yapi_tipi: "FVG", geri_bak_gun: 5 };
        case "Topdown Cascade":
            return { topdown_mod: piyasa };
        case "Hacim Profili Tarama":
            return { tarama_periyot: "1 Gün", min_skor: 0, mum_sayisi: 300, sinyal_filtre: [] };
        case "Hacim Akışı Tarama":
            return { lookback: 20, min_spike: 1.5, sinyal_filtre: {"📈 Güçlü Alım":true,"🔶 Orta Alım":true,"⬇️ Zayıf Alım":false,"📉 Güçlü Satım":true,"🔶 Orta Satım":true,"⬆️ Zayıf Satım":false,"⚖️ Belirsiz":false} };
        case "Divergence Tarama":
            return { tarama_periyot: "1 Gün", pivot_modu: "fractal", osilatorler: {"RSI":true,"MACD Histogram":true,"Stokastik RSI":true,"OBV":false}, divergence_tipleri: {"Regular Bullish":true,"Regular Bearish":true,"Hidden Bullish":false,"Hidden Bearish":false}, swing_pencere:5, zigzag_esik:1, n_son_pivot:2, min_pivot_mesafe:3, min_hareket_atr:0, rsi_periyot:14, macd_fast:12, macd_slow:26, macd_signal:9, stoch_rsi_periyot:14, stoch_periyot:14, stoch_k:3, stoch_d:3, ayarlar_acik:false };
        default: return {};
    }
}

// ─── API payload oluşturucu ────────────────────────────────────
function buildPayload(modul, filtre, piyasa, paraBirimi, hisseListesi) {
    const pb = piyasa === "BIST" ? paraBirimi : "USD";
    const base = { mod: piyasa, para_birimi: pb, hisse_listesi: hisseListesi || null };

    switch (modul) {
		case "Dip Tarama":
			return { ...base, periyot: DIP_PERIYOT_MAP[filtre.periyot] || "yil", tolerans: TOLERANS_MAP[filtre.tolerans] ?? 0.03, hizli_tarama: false };
		case "Likidite Tarama":
            return { ...base, sweep_tipler: Object.keys(filtre.sweep_tipler).filter(k => filtre.sweep_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], lookback: filtre.lookback, wick_oran: filtre.wick_oran / 100 };
        case "FVG Tarama":
            return {
                ...base,
                fvg_tipler: Object.keys(filtre.fvg_tipler).filter(k => filtre.fvg_tipler[k]),
                bpr_kontrol: filtre.bpr_kontrol === true || filtre.bpr_kontrol === "Evet",
                tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot] || filtre.tarama_periyot || "1mo",
                tarama_metodu: filtre.tarama_metodu || "Tüm Hisselerde",
                dip_periyot: filtre.tarama_metodu === "Dip Altı Hisselerde" ? (DIP_PERIYOT_MAP[filtre.dip_periyodu] || "yil") : null,
                mum_sayisi: filtre.mum_sayisi || 100,
            };
		case "Çapa Noktası Tarama":
            return { ...base, fvg_tipler: Object.keys(filtre.fvg_tipler).filter(k => filtre.fvg_tipler[k]), tolerans: filtre.tolerans / 100 };
        case "MSB Tarama":
            return { ...base, msb_tipler: Object.keys(filtre.msb_tipler).filter(k => filtre.msb_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], swing_pencere: filtre.swing_pencere };
        case "OTE Tarama":
            return { ...base, ote_tipler: Object.keys(filtre.ote_tipler).filter(k => filtre.ote_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], swing_pencere: filtre.swing_pencere, mum_sayisi: filtre.mum_sayisi };
        case "OB & BB Tarama":
            return { ...base, obbb_tipler: Object.keys(filtre.obbb_tipler).filter(k => filtre.obbb_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], mum_sayisi: filtre.mum_sayisi, govde_oran: filtre.govde_oran / 100, sadece_taze: filtre.sadece_taze };
        case "IDM Tarama":
            return { ...base, idm_tipler: Object.keys(filtre.idm_tipler).filter(k => filtre.idm_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], mum_sayisi: filtre.mum_sayisi };
        case "P/D Zone Tarama":
            return { ...base, bolge_filtre: Object.keys(filtre.bolge_filtre).filter(k => filtre.bolge_filtre[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], range_window: filtre.range_window, mum_sayisi: filtre.mum_sayisi };
        case "SMT Tarama":
            return { ...base, smt_tipler: Object.keys(filtre.smt_tipler).filter(k => filtre.smt_tipler[k]), tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot], referans_varlik: filtre.referans_varlik, swing_pencere: filtre.swing_pencere, kor_pencere: filtre.kor_pencere, min_korelasyon: filtre.min_korelasyon / 100, mum_sayisi: filtre.mum_sayisi };
        case "Killzone Tarama":
            return { ...base, killzoneler: Object.keys(filtre.killzoneler||{}).filter(k=>filtre.killzoneler[k]), yapi_tipleri: [filtre.yapi_tipi].filter(Boolean), geri_bak_gun: filtre.geri_bak_gun };
        case "Topdown Cascade":
            return { ...base };
        case "Hacim Profili Tarama": {
            const hpSF = filtre.sinyal_filtre || [];
            return { ...base,
                tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot] || filtre.tarama_periyot || "1d",
                min_skor: filtre.min_skor || 0,
                mum_sayisi: filtre.mum_sayisi || 300,
                sinyal_filtre: Array.isArray(hpSF) ? hpSF : Object.keys(hpSF).filter(k=>hpSF[k]),
            };
        }
        case "Hacim Akışı Tarama": {
            const haSF = filtre.sinyal_filtre || {};
            return { ...base,
                lookback: filtre.lookback || 20,
                min_spike: filtre.min_spike || 1.5,
                sinyal_filtre: Array.isArray(haSF) ? haSF : Object.keys(haSF).filter(k=>haSF[k]),
            };
        }
        case "Divergence Tarama": {
            const divOsc = filtre.osilatorler || {};
            const divTip = filtre.divergence_tipleri || {};
            return { ...base,
                tarama_periyot: PERIYOT_MAP[filtre.tarama_periyot] || filtre.tarama_periyot || "1d",
                pivot_modu: filtre.pivot_modu || "fractal",
                osilatorler: Array.isArray(divOsc) ? divOsc : Object.keys(divOsc).filter(k=>divOsc[k]),
                divergence_tipleri: Array.isArray(divTip) ? divTip : Object.keys(divTip).filter(k=>divTip[k]),
                swing_pencere: filtre.swing_pencere || 5,
                zigzag_esik: filtre.zigzag_esik || 1,
                n_son_pivot: filtre.n_son_pivot || 2,
                min_pivot_mesafe: filtre.min_pivot_mesafe || 3,
                min_hareket_atr: filtre.min_hareket_atr || 0,
                rsi_periyot: filtre.rsi_periyot || 14,
                macd_fast: filtre.macd_fast || 12,
                macd_slow: filtre.macd_slow || 26,
                macd_signal: filtre.macd_signal || 9,
                stoch_rsi_periyot: filtre.stoch_rsi_periyot || 14,
                stoch_periyot: filtre.stoch_periyot || 14,
                stoch_k: filtre.stoch_k || 3,
                stoch_d: filtre.stoch_d || 3,
            };
        }
        default: return base;
    }
}

function endpointFor(modul) {
    const map = {
        "Dip Tarama": "/scan/dip-tara",
        "Likidite Tarama": "/scan/likidite-tara",
        "FVG Tarama": "/scan/fvg-tara",
        "Çapa Noktası Tarama": "/scan/capa-tara",
        "MSB Tarama": "/scan/msb-tara",
        "OTE Tarama": "/scan/ote-tara",
        "OB & BB Tarama": "/scan/obbb-tara",
        "IDM Tarama": "/scan/inducement-tara",
        "P/D Zone Tarama": "/scan/pd-tara",
        "SMT Tarama": "/scan/smt-tara",
        "Killzone Tarama": "/scan/killzone-tara",
        "Topdown Cascade": "/scan/topdown-cascade-tara",
        "Hacim Profili Tarama": "/scan/hacim-profili-tara",
        "Hacim Akışı Tarama": "/scan/hacim-akisi-tara",
        "Divergence Tarama": "/scan/divergence-tara",
    };
    return map[modul] || null;
}

function hisselerdenCikar(sonuc, modul) {
    const arr = modul === "Dip Tarama"
        ? (sonuc?.dip || [])
        : modul === "Topdown Cascade"
        ? (sonuc?.sonuclar || [])
        : (sonuc?.sonuclar || []);
    const set = new Set(arr.map(r => r["Hisse"] || r["hisse"] || r["symbol"]));
    return [...set].filter(Boolean);
}

// ─── Modül filtre UI bileşeni ──────────────────────────────────
function ModulFiltresi({ modul, filtre, onChange, piyasa, paraBirimi, periyotlar }) {
    const dynPeriyotlar = (periyotlar && periyotlar.length > 0) ? periyotlar : PERIYOT_OPTS;
    const s = styles;
    const ck = (grup, key) => onChange({ ...filtre, [grup]: { ...filtre[grup], [key]: !filtre[grup][key] } });
    const set = (key, val) => onChange({ ...filtre, [key]: val });

    const CheckGrup = ({ alan, etiket }) => (
        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
            <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>{etiket}</legend>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {Object.keys(filtre[alan] || {}).map(k => {
                    const aktif = !!filtre[alan][k];
                    return (
                        <button key={k} type="button" onClick={() => ck(alan, k)} style={{
                            padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,
                            border:`2px solid ${aktif?C.accent:C.border}`,
                            background:aktif?C.accent+"22":"transparent",
                            color:aktif?C.accent:C.muted,
                        }}>{k}</button>
                    );
                })}
            </div>
        </fieldset>
    );

    const Sel = ({ alan, etiket, opts, labelFn }) => (
        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
            <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>{etiket.toUpperCase()}</legend>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {opts.map(o => {
                    const aktif = filtre[alan] === o || filtre[alan] === (isNaN(o) ? o : Number(o));
                    return (
                        <button key={o} type="button" onClick={() => set(alan, isNaN(o) ? o : Number(o))} style={{
                            padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,
                            border:`2px solid ${aktif?C.accent:C.border}`,
                            background:aktif?C.accent+"22":"transparent",
                            color:aktif?C.accent:C.muted,
                        }}>{labelFn ? labelFn(o) : o}</button>
                    );
                })}
            </div>
        </fieldset>
    );

    switch (modul) {
        case "Dip Tarama":
            return (<>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <div style={{display:"flex",gap:6}}>
                        {(dynPeriyotlar.length > 0 ? dynPeriyotlar : DIP_PERIYOT_OPTS).map(p=>(
                            <button key={p} onClick={()=>set("periyot",p)} style={{padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",border:`2px solid ${filtre.periyot===p?C.teal:C.border}`,background:filtre.periyot===p?C.teal+"22":"transparent",color:filtre.periyot===p?C.teal:C.muted}}>{p}</button>
                        ))}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>TOLERANS <BilgiIkonu alan="tolerans"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {Object.keys(TOLERANS_MAP).map(t=>(
                            <button key={t} onClick={()=>set("tolerans",t)} style={{padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",border:`2px solid ${filtre.tolerans===t?C.gold:C.border}`,background:filtre.tolerans===t?C.gold+"22":"transparent",color:filtre.tolerans===t?C.gold:C.muted}}>{t}</button>
                        ))}
                    </div>
                </fieldset>
            </>);
        case "Likidite Tarama":
            return (<>
                <CheckGrup alan="sweep_tipler" etiket="Sweep Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>LOOKBACK <BilgiIkonu alan="lookback"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,60,75,100].map(v=>{const aktif=filtre.lookback===v;return(<button key={v} type="button" onClick={()=>set("lookback",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN FİTİL <BilgiIkonu alan="wick_oran"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[30,40,50,60,70].map(v=>{const aktif=filtre.wick_oran===v;return(<button key={v} type="button" onClick={()=>set("wick_oran",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.gold:C.border}`,background:aktif?C.gold+"22":"transparent",color:aktif?C.gold:C.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "FVG Tarama": {
            const iFVGsecili = !!filtre.fvg_tipler?.["iFVG"];
            const bprAktif = iFVGsecili;
            const dipAktif = filtre.tarama_metodu === "Dip Altı Hisselerde";
            return (<>
                <CheckGrup alan="fvg_tipler" etiket="FVG Tipi" />
                {/* BPR Kontrol */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:bprAktif?1:0.4,pointerEvents:bprAktif?"auto":"none"}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>BPR KONTROL <BilgiIkonu alan="bpr_kontrol"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {["Evet","Hayır"].map(v=>{
                            const aktif = bprAktif && (v==="Evet")===!!(filtre.bpr_kontrol);
                            return(<button key={v} type="button" onClick={()=>set("bpr_kontrol",v==="Evet")} style={{padding:"4px 14px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                {/* Periyot select */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Ay"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                {/* Tarama Metodu */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>TARAMA METODU <BilgiIkonu alan="tarama_metodu"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {["Dip Altı Hisselerde","Tüm Hisselerde"].map(v=>{const aktif=filtre.tarama_metodu===v;return(<button key={v} type="button" onClick={()=>set("tarama_metodu",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.teal:C.border}`,background:aktif?C.teal+"22":"transparent",color:aktif?C.teal:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
                {/* Dip Periyodu */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:dipAktif?1:0.4,pointerEvents:dipAktif?"auto":"none"}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>DİP PERİYODU <BilgiIkonu alan="dip_periyodu"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {["Yıllık","6 Aylık","3 Aylık","1 Ay"].map(v=>{
                            const aktif = dipAktif && filtre.dip_periyodu===v;
                            return(<button key={v} type="button" onClick={()=>set("dip_periyodu",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.gold:C.border}`,background:aktif?C.gold+"22":"transparent",color:aktif?C.gold:C.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                {/* Mum Sayısı select */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="fvg_mum_sayisi"/></legend>
                    <select value={filtre.mum_sayisi||100} onChange={e=>set("mum_sayisi",Number(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {[25,50,100,150,200,250,300,350,400,500,600,700].map(v=><option key={v} value={v}>{v}</option>)}
                    </select>
                </fieldset>
            </>);
        }
        case "Çapa Noktası Tarama":
            return (<>
                <CheckGrup alan="fvg_tipler" etiket="FVG Tipi" />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>TOLERANS <BilgiIkonu alan="capa_tolerans"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[30,50,70,80,90,100].map(v=>{const aktif=filtre.tolerans===v;return(<button key={v} type="button" onClick={()=>set("tolerans",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.gold:C.border}`,background:aktif?C.gold+"22":"transparent",color:aktif?C.gold:C.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "MSB Tarama":
            return (<>
                <CheckGrup alan="msb_tipler" etiket="MSB Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SWING PENCERESİ <BilgiIkonu alan="swing_penceresi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,4,5,6,7,8].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
            </>);
        case "OTE Tarama":
            return (<>
                <CheckGrup alan="ote_tipler" etiket="OTE Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SWING PENCERESİ <BilgiIkonu alan="swing_penceresi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,5,7].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="ote_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,100,150,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "OB & BB Tarama":
            return (<>
                <CheckGrup alan="obbb_tipler" etiket="OB/BB Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="obbb_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN GÖVDE ORANI <BilgiIkonu alan="govde_oran"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[40,50,60,70].map(v=>{const aktif=filtre.govde_oran===v;return(<button key={v} type="button" onClick={()=>set("govde_oran",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.gold:C.border}`,background:aktif?C.gold+"22":"transparent",color:aktif?C.gold:C.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SADECE TAZE <BilgiIkonu alan="sadece_taze"/></legend>
                    <button type="button" onClick={()=>set("sadece_taze",!filtre.sadece_taze)} style={{padding:"4px 14px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:filtre.sadece_taze?600:400,border:`2px solid ${filtre.sadece_taze?C.accent:C.border}`,background:filtre.sadece_taze?C.accent+"22":"transparent",color:filtre.sadece_taze?C.accent:C.muted}}>{filtre.sadece_taze?"✅ Açık":"Kapalı"}</button>
                </fieldset>
            </>);
        case "IDM Tarama":
            return (<>
                <CheckGrup alan="idm_tipler" etiket="IDM Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="idm_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,150,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "P/D Zone Tarama":
            return (<>
                {/* Bölge: Deep Discount ve Extreme Premium çıkarıldı */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>BÖLGE</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {Object.keys(filtre.bolge_filtre||{}).filter(k=>k!=="Deep Discount"&&k!=="Extreme Premium").map(k=>{
                            const aktif=!!filtre.bolge_filtre[k];
                            return(<button key={k} type="button" onClick={()=>set("bolge_filtre",{...filtre.bolge_filtre,[k]:!filtre.bolge_filtre[k]})} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{k}</button>);
                        })}
                    </div>
                </fieldset>
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>RANGE PENCERESİ <BilgiIkonu alan="range_penceresi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[10,20,50,100].map(v=>{const aktif=filtre.range_window===v;return(<button key={v} type="button" onClick={()=>set("range_window",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.teal:C.border}`,background:aktif?C.teal+"22":"transparent",color:aktif?C.teal:C.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="pd_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "SMT Tarama":
            return (<>
                <CheckGrup alan="smt_tipler" etiket="SMT Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SWING PENCERESİ <BilgiIkonu alan="smt_swing"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,5].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>REFERANS VARLIK</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {(piyasa === "BIST" ? ["XU100 (BIST100)","XU030 (BIST30)"] : ["BTC","ETH","BNB"]).map(v => {
                            const aktif = filtre.referans_varlik === v;
                            return(<button key={v} type="button" onClick={()=>set("referans_varlik",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN KORELASYON <BilgiIkonu alan="smt_korelasyon"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,60,70,80,90].map(v=>{const aktif=filtre.min_korelasyon===v;return(<button key={v} type="button" onClick={()=>set("min_korelasyon",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="smt_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "Killzone Tarama":
            return (<>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>KILLZONE <BilgiIkonu alan="kz_killzone"/></legend>
                    <select value={filtre.killzoneler ? Object.keys(filtre.killzoneler).find(k=>filtre.killzoneler[k])||"" : ""} onChange={e=>{const yeni={};KZ_LISTESI.forEach(k=>yeni[k]=false);if(e.target.value)yeni[e.target.value]=true;set("killzoneler",yeni);}} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer",minWidth:220}}>
                        {KZ_LISTESI.map(k=><option key={k} value={k}>{k}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>YAPI TİPİ <BilgiIkonu alan="kz_yapi_tipi"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {["FVG","MSB","Sweep"].map(v=>{
                            const aktif = filtre.yapi_tipi === v;
                            return(<button key={v} type="button" onClick={()=>set("yapi_tipi",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>GERİYE BAKIŞ <BilgiIkonu alan="kz_geri_bakis"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {[3,5,7,10].map(v=>{const aktif=filtre.geri_bak_gun===v;return(<button key={v} type="button" onClick={()=>set("geri_bak_gun",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.teal:C.border}`,background:aktif?C.teal+"22":"transparent",color:aktif?C.teal:C.muted}}>{v} Gün</button>);})}
                    </div>
                </fieldset>
            </>);
        case "Topdown Cascade":
            return <div style={s.filtreGrup}><label style={s.etiket}>Mod</label><span style={{fontSize:12,color:"#64748b"}}>{piyasa} — EMA200 + 4H Sweep taraması</span></div>;
        case "Hacim Profili Tarama": {
            const HP_SINYALLER = ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"];
            return (<>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Gün"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SİNYAL FİLTRESİ <BilgiIkonu alan="hp_sinyal_filtresi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {HP_SINYALLER.map(v=>{
                            const sf = filtre.sinyal_filtre || [];
                            const aktif = Array.isArray(sf) ? sf.includes(v) : !!sf[v];
                            return(<button key={v} type="button" onClick={()=>{const cur=Array.isArray(filtre.sinyal_filtre)?filtre.sinyal_filtre:[];set("sinyal_filtre",aktif?cur.filter(x=>x!==v):[...cur,v]);}} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <Sel alan="min_skor" etiket="Min Skor" opts={[0,2,3,4,5,6,7]} labelFn={v=>v===0?"Tümü":`≥${v}`} />
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MUM SAYISI <BilgiIkonu alan="hp_mum_sayisi"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":"transparent",color:aktif?C.accent:C.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        }
        case "Hacim Akışı Tarama": {
            const HA_SINYAL_RENK = {"📈 Güçlü Alım":"#16a34a","🔶 Orta Alım":"#84cc16","⬇️ Zayıf Alım":"#a3e635","📉 Güçlü Satım":"#dc2626","🔶 Orta Satım":"#f97316","⬆️ Zayıf Satım":"#fca5a5","⚖️ Belirsiz":"#9ca3af"};
            const haSinyalFiltre = filtre.sinyal_filtre || {};
            const toggleHA = s => { const sf = typeof haSinyalFiltre === "object" && !Array.isArray(haSinyalFiltre) ? haSinyalFiltre : {}; set("sinyal_filtre", {...sf, [s]:!sf[s]}); };
            return (<>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>ORT. PENCERE (GÜN) <BilgiIkonu alan="ha_ort_pencere"/></legend>
                    <select value={filtre.lookback||20} onChange={e=>set("lookback",Number(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {[5,10,20,30,40,50].map(v=><option key={v} value={v}>{v} Gün</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN. SPİKE (×ORT.) <BilgiIkonu alan="ha_min_spike"/></legend>
                    <input type="number" value={filtre.min_spike||1.5} min={1.0} max={10} step={0.1} onChange={e=>set("min_spike",parseFloat(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:80}}/>
                </fieldset>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SİNYAL TİPİ <BilgiIkonu alan="ha_sinyal_tipi"/></legend>
                    <div style={{display:"flex",gap:8}}>
                        <div style={{background:C.bg,border:`1px solid ${"#16a34a"}55`,borderRadius:6,padding:"6px 10px"}}>
                            <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:4}}>📈 ALIMLAR</div>
                            {["📈 Güçlü Alım","🔶 Orta Alım","⬇️ Zayıf Alım","⚖️ Belirsiz"].map(s=>{
                                const aktif=!!(typeof haSinyalFiltre==="object"&&!Array.isArray(haSinyalFiltre)?haSinyalFiltre[s]:Array.isArray(haSinyalFiltre)&&haSinyalFiltre.includes(s));
                                return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"3px 6px",borderRadius:6,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_SINYAL_RENK[s]+"22":"transparent",border:`1px solid ${aktif?HA_SINYAL_RENK[s]:C.border}`,color:aktif?HA_SINYAL_RENK[s]:C.muted}}>{s}</button>);
                            })}
                        </div>
                        <div style={{background:C.bg,border:`1px solid ${"#dc2626"}55`,borderRadius:6,padding:"6px 10px"}}>
                            <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:4}}>📉 SATIMLAR</div>
                            {["📉 Güçlü Satım","🔶 Orta Satım","⬆️ Zayıf Satım"].map(s=>{
                                const aktif=!!(typeof haSinyalFiltre==="object"&&!Array.isArray(haSinyalFiltre)?haSinyalFiltre[s]:Array.isArray(haSinyalFiltre)&&haSinyalFiltre.includes(s));
                                return(<button key={s} type="button" onClick={()=>toggleHA(s)} style={{display:"block",width:"100%",textAlign:"left",padding:"3px 6px",borderRadius:6,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_SINYAL_RENK[s]+"22":"transparent",border:`1px solid ${aktif?HA_SINYAL_RENK[s]:C.border}`,color:aktif?HA_SINYAL_RENK[s]:C.muted}}>{s}</button>);
                            })}
                        </div>
                    </div>
                </fieldset>
            </>);
        }
        case "Divergence Tarama": {
            const DIV_OSC = ["RSI","MACD Histogram","Stokastik RSI","OBV"];
            const DIV_TIPLER = [
                {key:"Regular Bullish",ikon:"📈",renk:"#16a34a",label:"Regular Bullish"},
                {key:"Regular Bearish",ikon:"📉",renk:"#dc2626",label:"Regular Bearish"},
                {key:"Hidden Bullish",ikon:"🔼",renk:"#06b6d4",label:"Hidden Bullish"},
                {key:"Hidden Bearish",ikon:"🔽",renk:"#f59e0b",label:"Hidden Bearish"},
            ];
            const divOsc = filtre.osilatorler || {};
            const divTip = filtre.divergence_tipleri || {};
            const toggleOsc = o => set("osilatorler", {...divOsc, [o]:!divOsc[o]});
            const toggleTip = t => set("divergence_tipleri", {...divTip, [t]:!divTip[t]});
            const ayarlarAcik = filtre.ayarlar_acik || false;
            const stochAktif = !!divOsc["Stokastik RSI"];
            const macdAktif = !!divOsc["MACD Histogram"];
            const rsiAktif = !!divOsc["RSI"];
            return (<>
                {/* Periyot */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Gün"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                {/* Pivot Modu */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>PİVOT MODU <BilgiIkonu alan="div_pivot_modu"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {[["fractal","Fractal"],["zigzag","ZigZag"]].map(([v,l])=>{
                            const aktif=(filtre.pivot_modu||"fractal")===v;
                            return(<button key={v} type="button" onClick={()=>set("pivot_modu",v)} style={{padding:"5px 12px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer",border:`1px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":C.bg,color:aktif?C.accent:C.muted}}>{l}</button>);
                        })}
                    </div>
                </fieldset>
                {/* Osilatörler */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>OSİLATÖRLER <BilgiIkonu alan="div_osilatorler"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {DIV_OSC.map(o=>{const aktif=!!divOsc[o];return(<button key={o} type="button" onClick={()=>toggleOsc(o)} style={{padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"18":C.bg,color:aktif?C.accent:C.muted}}>{o}</button>);})}
                    </div>
                </fieldset>
                {/* Divergence Tipleri */}
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>DIVERGENCE TİPLERİ <BilgiIkonu alan="div_tipler"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {DIV_TIPLER.map(t=>{const aktif=!!divTip[t.key];return(<button key={t.key} type="button" onClick={()=>toggleTip(t.key)} style={{padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?t.renk:C.border}`,background:aktif?t.renk+"18":C.bg,color:aktif?t.renk:C.muted}}>{t.ikon} {t.label}</button>);})}
                    </div>
                </fieldset>
                {/* Gelişmiş Ayarlar toggle */}
                <button type="button" onClick={()=>set("ayarlar_acik",!ayarlarAcik)} style={{padding:"6px 12px",borderRadius:8,border:`1px solid ${C.border}`,background:ayarlarAcik?C.border:C.bg,color:C.text,fontSize:11,fontWeight:600,cursor:"pointer",alignSelf:"flex-start"}}>
                    ⚙️ Gelişmiş Ayarlar {ayarlarAcik?"▲":"▼"}
                </button>
                {/* Gelişmiş Ayarlar */}
                {ayarlarAcik && (<>
                    {(filtre.pivot_modu||"fractal")==="fractal"
                        ? (<fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:120}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>SWING PENCERESİ <BilgiIkonu alan="div_swing_pencere"/></legend><input type="number" value={filtre.swing_pencere||5} min={2} max={20} onChange={e=>set("swing_pencere",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>)
                        : (<fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:120}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>ZİGZAG EŞİK (%)</legend><input type="number" value={filtre.zigzag_esik||1} min={0.5} max={20} step={0.5} onChange={e=>set("zigzag_esik",parseFloat(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>)
                    }
                    <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:140}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>KARŞILAŞTIRILAN PİVOT <BilgiIkonu alan="div_karsilastirilan_pivot"/></legend>
                        <div style={{display:"flex",gap:6}}>{[2,3].map(n=>{const aktif=(filtre.n_son_pivot||2)===n;return(<button key={n} type="button" onClick={()=>set("n_son_pivot",n)} style={{flex:1,padding:"6px",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",border:`1px solid ${aktif?C.accent:C.border}`,background:aktif?C.accent+"22":C.bg,color:aktif?C.accent:C.muted}}>{n}</button>);})}</div>
                    </fieldset>
                    <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:130}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN PİVOT MESAFE <BilgiIkonu alan="div_min_pivot"/></legend>
                        <input type="number" value={filtre.min_pivot_mesafe||3} min={0} max={20} onChange={e=>set("min_pivot_mesafe",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/>
                    </fieldset>
                    <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:130}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MİN HAREKET (xATR) <BilgiIkonu alan="div_min_hareket"/></legend>
                        <input type="number" value={filtre.min_hareket_atr||0} min={0} max={5} step={0.1} onChange={e=>set("min_hareket_atr",parseFloat(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/>
                    </fieldset>
                    {rsiAktif && <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:110}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>RSI PERİYOT <BilgiIkonu alan="div_rsi_periyot"/></legend><input type="number" value={filtre.rsi_periyot||14} min={2} max={50} onChange={e=>set("rsi_periyot",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>}
                    {macdAktif && <>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:90}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MACD FAST <BilgiIkonu alan="div_macd_fast"/></legend><input type="number" value={filtre.macd_fast||12} min={2} max={50} onChange={e=>set("macd_fast",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:90}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MACD SLOW <BilgiIkonu alan="div_macd_slow"/></legend><input type="number" value={filtre.macd_slow||26} min={5} max={100} onChange={e=>set("macd_slow",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:90}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>MACD SİGNAL <BilgiIkonu alan="div_macd_signal"/></legend><input type="number" value={filtre.macd_signal||9} min={2} max={50} onChange={e=>set("macd_signal",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                    </>}
                    {stochAktif && <>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:110}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>STOCHRSI RSI PER. <BilgiIkonu alan="div_stoch_rsi_periyot"/></legend><input type="number" value={filtre.stoch_rsi_periyot||14} min={2} max={50} onChange={e=>set("stoch_rsi_periyot",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:115}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>STOCHRSI STOCH PER. <BilgiIkonu alan="div_stoch_periyot"/></legend><input type="number" value={filtre.stoch_periyot||14} min={2} max={50} onChange={e=>set("stoch_periyot",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:75}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>%K <BilgiIkonu alan="div_stoch_k"/></legend><input type="number" value={filtre.stoch_k||3} min={1} max={20} onChange={e=>set("stoch_k",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                        <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,minWidth:75}}><legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>%D <BilgiIkonu alan="div_stoch_d"/></legend><input type="number" value={filtre.stoch_d||3} min={1} max={20} onChange={e=>set("stoch_d",parseInt(e.target.value))} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,color:C.text,padding:"5px 10px",fontSize:12,width:70}}/></fieldset>
                    </>}
                </>)}
            </>);
        }
        default:
            return null;
    }
}

// ─── Ana bileşen ──────────────────────────────────────────────
export default function CokluTarama() {
    const navigate = useNavigate();
    const location = useLocation();

    // Puanlamaya Gönder popup — adım: null | "kriter" | "onay"
    const [puanlamaPopupAdim, setPuanlamaPopupAdim] = useState(null);
    const [puanlamaVade,      setPuanlamaVade]      = useState(null);
    const [puanlamaYon,       setPuanlamaYon]       = useState(new Set(["Long", "Short"]));
    const [puanlamaMinPuan,   setPuanlamaMinPuan]   = useState(0);

    const [gecmisPopupAdim,  setGecmisPopupAdim]  = useState(null);
    const [gecmisSimTarihi,  setGecmisSimTarihi]  = useState(() => {
        const d = new Date(); d.setFullYear(d.getFullYear() - 1);
        return d.toISOString().split("T")[0];
    });
    const [gecmisRefFiyat,   setGecmisRefFiyat]   = useState("Bugünkü");
    const [piyasa,      setPiyasa]      = useState("BIST");
    const [paraBirimi,  setParaBirimi]  = useState("USD");
    const [adimlar,     setAdimlar]     = useState([
        { modul: "Dip Tarama", filtre: defaultFiltreler("Dip Tarama", "BIST"), sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "", bulunan:0, tamamlanan:0, toplam:0 }
    ]);
    const [secilenler,          setSecilenler]          = useState(new Set());
    const [islemMenuAcik,       setIslemMenuAcik]       = useState(false);
    const [dogrulukKaydediliyor,setDogrulukKaydediliyor]= useState(false);
    const [dogrulukPopup,       setDogrulukPopup]       = useState(null); // null | "yukleniyor" | "tamam"
    const [dogrulukSonuc,       setDogrulukSonuc]       = useState(null);
    const [alarmPopup,          setAlarmPopup]          = useState(false);
    const [alarmHisseler,       setAlarmHisseler]       = useState([]);
    const [hedefFiyatlar,       setHedefFiyatlar]       = useState({});
    const [alarmMail,           setAlarmMail]           = useState(false);
    const [alarmBildirim,       setAlarmBildirim]       = useState(true);
    const [alarmKaydediliyor,   setAlarmKaydediliyor]   = useState(false);
    const [piyasaSecenekleri,    setPiyasaSecenekleri]    = useState(["BIST","Kripto"]);
    const [paraBirimiSecenekleri,setParaBirimiSecenekleri]= useState(["USD","TL","BIST100 (TL)","BIST100 (USD)"]);
    const intervalRefs = useRef({});
    // Dışarıdan gelen state ile oto-başlatma (bir kez çalışır)
    const otoBaslatRef = useRef(false);

    const getToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.access_token;
    };

    useEffect(()=>{
        getLookupPiyasalar().then(p=>setPiyasaSecenekleri(p)).catch(()=>{});
        // Sadece oto_baslat yoksa mount periyot yükle
        if (!location.state?.oto_baslat) {
            periyotlariYukle(adimlar);
        }
    },[]);

    useEffect(()=>{
        getLookupParaBirimleri(piyasa,"coklu_tarama")
            .then(pb=>{setParaBirimiSecenekleri(pb);})
            .catch(()=>{});
    },[piyasa]);

    // Dışarıdan gelen state (örn. Dip Tarama → Çoklu Tarama)
    useEffect(() => {
        const st = location.state;
        if (!st || !st.oto_baslat || otoBaslatRef.current) return;
        otoBaslatRef.current = true;

        const gelenPiyasa   = st.piyasa      || "BIST";
        const gelenPB       = st.paraBirimi  || "USD";
        const gelenModul    = st.modul;
        const gelenFiltre   = st.filtre      || defaultFiltreler(gelenModul, gelenPiyasa);
        const gelenHisseler = st.hisseListesi || null;

        // Kaynak tarama bilgisi (Dip/Likidite gibi — zaten tamamlanmış)
        const kaynakModul         = st.kaynakModul || null;
        const kaynakFiltre        = st.kaynakFiltre || null;
        const kaynakSonucHisseler = st.kaynakSonucHisseler || null;

        setPiyasa(gelenPiyasa);
        setParaBirimi(gelenPB);

        if (kaynakModul) {
            // sinyal_filtre dict ise array'e çevir
            const normalizeFiltre = (f) => {
				if (!f) return f;
				const result = { ...f };
				if (f.sinyal_filtre && !Array.isArray(f.sinyal_filtre))
					result.sinyal_filtre = Object.keys(f.sinyal_filtre).filter(k => f.sinyal_filtre[k]);
				if ("bpr_kontrol" in f)
					result.bpr_kontrol = f.bpr_kontrol === true || f.bpr_kontrol === "Evet";
				return result;
			};
            const normKaynakFiltre = normalizeFiltre(kaynakFiltre);
            // İki adımlı: birinci kriter kaynak (tamamlanmış), ikinci kriter seçilen modül (otomatik başlayacak)
            const kaynakAdim = {
                modul: kaynakModul,
                filtre: normKaynakFiltre || defaultFiltreler(kaynakModul, gelenPiyasa),
                hisseListesi: kaynakSonucHisseler,
                // Tamamlanmış gibi göster — mock sonuç
                sonuc: {
                    sonuclar: (kaynakSonucHisseler||[]).map(h=>({Hisse:h})),
                    dip: (kaynakSonucHisseler||[]).map(h=>({Hisse:h})),
                    toplam: (kaynakSonucHisseler||[]).length,
                },
                calisiyor: false, ilerleme: 100, mesaj: "",
                bulunan: (kaynakSonucHisseler||[]).length, tamamlanan: 0, toplam: 0, periyotlar: [],
            };
            const ikinciAdim = {
                modul: gelenModul,
                filtre: gelenFiltre,
                hisseListesi: gelenHisseler,
                sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "",
                bulunan: 0, tamamlanan: 0, toplam: 0, periyotlar: [],
            };
            setAdimlar([kaynakAdim, ikinciAdim]);
            periyotlariYukle([kaynakAdim, ikinciAdim]);

            // İkinci adımı otomatik başlat
            setTimeout(async () => {
                const ep = endpointFor(gelenModul);
                if (!ep) { toast.error(`"${gelenModul}" için endpoint bulunamadı`); return; }
                try {
                    const { data: { session } } = await supabase.auth.getSession();
                    if (!session) return;
                    const payload = buildPayload(gelenModul, gelenFiltre, gelenPiyasa, gelenPB, gelenHisseler);
                    setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, calisiyor: true, mesaj: "Başlatılıyor...", baslangicZaman: Date.now() } : a));
                    await axios.post(`${API_URL}${ep}`, payload, { headers: { Authorization: `Bearer ${session.access_token}` } });
                    toast.success(`${gelenModul} taraması başlatıldı!`);

                    intervalRefs.current[1] = setInterval(async () => {
                        try {
                            const { data: { session: s2 } } = await supabase.auth.getSession();
                            if (!s2) { clearInterval(intervalRefs.current[1]); return; }
                            const res = await axios.get(`${API_URL}/scan/durum`, { headers: { Authorization: `Bearer ${s2.access_token}` } });
                            const mesajStr = typeof res.data.mesaj === "string" ? res.data.mesaj : "";
                            const mesajParts = mesajStr.split("|");
                            const bulunan = mesajParts.length >= 1 && !isNaN(mesajParts[0]) ? parseInt(mesajParts[0]) : 0;
                            const tkParts = mesajParts.length >= 2 ? mesajParts[1].split("/") : [];
                            const tamamlanan = tkParts.length === 2 ? parseInt(tkParts[0]) : 0;
                            const toplam = tkParts.length === 2 ? parseInt(tkParts[1]) : 0;
                            const temizMesaj = mesajParts.length >= 3 ? mesajParts[2] : mesajStr;
							const gBulunan   = res.data.bulunan    || bulunan    || 0;
							const gTamamlanan = res.data.tamamlanan || tamamlanan || 0;
							const gToplam    = res.data.toplam     || toplam     || 0;
							setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, ilerleme: res.data.ilerleme || 0, mesaj: temizMesaj, bulunan: gBulunan, tamamlanan: gTamamlanan, toplam: gToplam } : a));
                            if (!res.data.calisiyor) {
                                clearInterval(intervalRefs.current[1]);
                                if (res.data.sonuc) {
                                    const sonuc = res.data.sonuc;
                                    const hisseler = hisselerdenCikar(sonuc, gelenModul);
                                    setAdimlar(prev => {
                                        const yeni = [...prev];
                                        yeni[1] = { ...yeni[1], sonuc, calisiyor: false, ilerleme: 100, bulunan: hisseler.length };
                                        // Üçüncü kriter: ikinci adımda hisse bulunduysa aç
                                        if (hisseler.length > 0 && yeni.length < MODULLER.length) {
                                            const sonrakiModul = MODULLER.find(m => !yeni.map(a => a.modul).includes(m)) || MODULLER[0];
                                            yeni.push({ modul: sonrakiModul, filtre: defaultFiltreler(sonrakiModul, gelenPiyasa), sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "", bulunan:0, tamamlanan:0, toplam:0, periyotlar:[] });
                                        }
                                        return yeni;
                                    });
                                    toast.success(`${gelenModul}: ${hisseler.length} hisse bulundu`);
                                } else if (res.data.hata) {
                                    toast.error(`${gelenModul}: ${res.data.hata}`);
                                    setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, calisiyor: false } : a));
                                }
                            }
                        } catch { clearInterval(intervalRefs.current[1]); setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, calisiyor: false } : a)); }
                    }, 3000);
                } catch (e) {
                    const detay = e.response?.data?.detail;
					toast.error(typeof detay === "string" ? detay : Array.isArray(detay) ? JSON.stringify(detay) : "Tarama başlatılamadı");
                    setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, calisiyor: false } : a));
                }
            }, 300);

            return; // Aşağıdaki tek adımlı oto-başlat çalışmasın
        }

        const ilkAdim = {
            modul: gelenModul,
            filtre: gelenFiltre,
            hisseListesi: gelenHisseler,
            sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "",
            bulunan: 0, tamamlanan: 0, toplam: 0, periyotlar: [],
        };
        setAdimlar([ilkAdim]);
        periyotlariYukle([ilkAdim]);

        // Kısa gecikme sonrası taramayı oto-başlat
        setTimeout(async () => {
            const ep = endpointFor(gelenModul);
            if (!ep) { toast.error(`"${gelenModul}" için endpoint bulunamadı`); return; }
            try {
                const { data: { session } } = await supabase.auth.getSession();
                if (!session) return;
                const payload = buildPayload(gelenModul, gelenFiltre, gelenPiyasa, gelenPB, gelenHisseler);
                setAdimlar(prev => prev.map((a, i) => i === 0 ? { ...a, calisiyor: true, mesaj: "Başlatılıyor...", baslangicZaman: Date.now() } : a));
                await axios.post(`${API_URL}${ep}`, payload, { headers: { Authorization: `Bearer ${session.access_token}` } });
                toast.success(`${gelenModul} taraması başlatıldı!`);

                intervalRefs.current[0] = setInterval(async () => {
                    try {
                        const { data: { session: s2 } } = await supabase.auth.getSession();
                        if (!s2) { clearInterval(intervalRefs.current[0]); return; }
                        const res = await axios.get(`${API_URL}/scan/durum`, { headers: { Authorization: `Bearer ${s2.access_token}` } });
                        const mesajStr = typeof res.data.mesaj === "string" ? res.data.mesaj : "";
                        const mesajParts = mesajStr.split("|");
                        const bulunan = mesajParts.length >= 1 && !isNaN(mesajParts[0]) ? parseInt(mesajParts[0]) : 0;
                        const tkParts = mesajParts.length >= 2 ? mesajParts[1].split("/") : [];
                        const tamamlanan = tkParts.length === 2 ? parseInt(tkParts[0]) : 0;
                        const toplam = tkParts.length === 2 ? parseInt(tkParts[1]) : 0;
                        const temizMesaj = mesajParts.length >= 3 ? mesajParts[2] : mesajStr;
						const gBulunan   = res.data.bulunan    || bulunan    || 0;
						const gTamamlanan = res.data.tamamlanan || tamamlanan || 0;
						const gToplam    = res.data.toplam     || toplam     || 0;
						setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, ilerleme: res.data.ilerleme || 0, mesaj: temizMesaj, bulunan: gBulunan, tamamlanan: gTamamlanan, toplam: gToplam } : a));
                        if (!res.data.calisiyor) {
                            clearInterval(intervalRefs.current[0]);
                            if (res.data.sonuc) {
                                const sonuc = res.data.sonuc;
                                const hisseler = hisselerdenCikar(sonuc, gelenModul);
                                setAdimlar(prev => {
                                    const yeni = [...prev];
                                    yeni[0] = { ...yeni[0], sonuc, calisiyor: false, ilerleme: 100 };
                                    if (hisseler.length > 0 && yeni.length < MODULLER.length) {
                                        const sonrakiModul = MODULLER.find(m => !yeni.map(a => a.modul).includes(m)) || MODULLER[0];
                                        yeni.push({ modul: sonrakiModul, filtre: defaultFiltreler(sonrakiModul, gelenPiyasa), sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "" });
                                    }
                                    return yeni;
                                });
                                toast.success(`${gelenModul}: ${hisseler.length} hisse bulundu`);
                            } else if (res.data.hata) {
                                toast.error(`${gelenModul}: ${res.data.hata}`);
                                setAdimlar(prev => prev.map((a, i) => i === 0 ? { ...a, calisiyor: false } : a));
                            }
                        }
                    } catch { clearInterval(intervalRefs.current[0]); setAdimlar(prev => prev.map((a, i) => i === 0 ? { ...a, calisiyor: false } : a)); }
                }, 3000);
            } catch (e) {
                toast.error(e.response?.data?.detail || "Tarama başlatılamadı");
                setAdimlar(prev => prev.map((a, i) => i === 0 ? { ...a, calisiyor: false } : a));
            }
        }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const MODUL_KEY_MAP = {
        "Dip Tarama":"dip_tarama","Likidite Tarama":"likidite_tarama","FVG Tarama":"fvg_tarama",
        "Çapa Noktası Tarama":"capa_noktasi_tarama","MSB Tarama":"msb_tarama","OTE Tarama":"ote_tarama",
        "OB & BB Tarama":"obbb_tarama","IDM Tarama":"idm_tarama","P/D Zone Tarama":"pd_zone_tarama",
        "SMT Tarama":"smt_tarama","Killzone Tarama":"killzone_tarama",
        "Topdown Cascade":"topdown_cascade_tarama","Hacim Profili Tarama":"hacim_profili_tarama",
        "Hacim Akışı Tarama":"hacim_akisi_tarama","Divergence Tarama":"divergence_tarama",
    };

    const periyotlariYukle = async (adimlarArr) => {
        const { getLookupPeriyotlar } = await import("./apiCache");
        await Promise.all(adimlarArr.map(async (adim, idx) => {
            const dbKey = MODUL_KEY_MAP[adim.modul];
            if (!dbKey) return;
            try {
                const periyotlar = await getLookupPeriyotlar(dbKey);
                if (periyotlar?.length > 0) {
                    setAdimlar(prev => prev.map((a, i) => i === idx ? { ...a, periyotlar } : a));
                }
            } catch {}
        }));
    };

    const handlePiyasaDegis = (yeniPiyasa) => {
        setPiyasa(yeniPiyasa);
        const yeniAdimlar = [{ modul: "Dip Tarama", filtre: defaultFiltreler("Dip Tarama", yeniPiyasa), sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "", periyotlar: [] }];
        setAdimlar(yeniAdimlar);
        periyotlariYukle(yeniAdimlar);
    };

    const setAdim = (idx, partial) => {
        setAdimlar(prev => prev.map((a, i) => i === idx ? { ...a, ...partial } : a));
    };

    const modulDegis = async (idx, modul) => {
        const yeniFiltre = defaultFiltreler(modul, piyasa);
        setAdimlar(prev => {
            const yeni = [...prev];
            yeni[idx] = { modul, filtre: yeniFiltre, sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "", periyotlar: [] };
            return yeni.slice(0, idx + 1);
        });
        // DB'den periyot seçeneklerini çek
        try {
            const dbKey = MODUL_KEY_MAP[modul];
            if (dbKey) {
                const { getLookupPeriyotlar } = await import("./apiCache");
                const periyotlar = await getLookupPeriyotlar(dbKey);
                if (periyotlar && periyotlar.length > 0) {
                    setAdimlar(prev => prev.map((a, i) => i === idx ? { ...a, periyotlar } : a));
                }
            }
        } catch {}
    };

    const filtreGuncelle = (idx, yeniFiltre) => {
        setAdim(idx, { filtre: yeniFiltre });
    };

    const taramaBaslat = async (idx) => {
        const adim = adimlar[idx];
        const ep = endpointFor(adim.modul);
        if (!ep) { toast.error("Endpoint bulunamadı"); return; }

        const oncekiHisseler = adim.hisseListesi
            ? adim.hisseListesi
            : idx > 0 ? hisselerdenCikar(adimlar[idx - 1].sonuc, adimlar[idx - 1].modul) : null;

        setAdim(idx, { calisiyor: true, sonuc: null, ilerleme: 0, mesaj: "Başlatılıyor...", bulunan:0, tamamlanan:0, toplam:0, baslangicZaman: Date.now() });

        try {
            const token = await getToken();
            const payload = buildPayload(adim.modul, adim.filtre, piyasa, paraBirimi, oncekiHisseler);
            await axios.post(`${API_URL}${ep}`, payload, { headers: { Authorization: `Bearer ${token}` } });
            toast.success(`${adim.modul} taraması başlatıldı!`);

            intervalRefs.current[idx] = setInterval(async () => {
                try {
                    const { data: { session } } = await supabase.auth.getSession();
                    if (!session) { clearInterval(intervalRefs.current[idx]); return; }
                    const res = await axios.get(`${API_URL}/scan/durum`, { headers: { Authorization: `Bearer ${session.access_token}` } });
                    // Parse pipe-delimited mesaj: "bulunan|tamamlanan/toplam|sembol"
                    const mesajStr = res.data.mesaj || "";
                    const mesajParts = mesajStr.split("|");
                    let bulunan = 0, tamamlanan = 0, toplam = 0, temizMesaj = mesajStr;
                    if (mesajParts.length >= 3) {
                        bulunan = parseInt(mesajParts[0]) || 0;
                        const tk = mesajParts[1].split("/");
                        tamamlanan = parseInt(tk[0]) || 0;
                        toplam = parseInt(tk[1]) || 0;
                        temizMesaj = mesajParts[2] || "";
                    }
                    // res.data içinde ayrı field varsa öncelikli kullan
                    if (res.data.bulunan != null) bulunan = res.data.bulunan;
                    if (res.data.tamamlanan != null) tamamlanan = res.data.tamamlanan;
                    if (res.data.toplam != null) toplam = res.data.toplam;
					const gBulunan   = res.data.bulunan    || bulunan    || 0;
					const gTamamlanan = res.data.tamamlanan || tamamlanan || 0;
					const gToplam    = res.data.toplam     || toplam     || 0;
					setAdimlar(prev => prev.map((a, i) => i === 1 ? { ...a, ilerleme: res.data.ilerleme || 0, mesaj: temizMesaj, bulunan: gBulunan, tamamlanan: gTamamlanan, toplam: gToplam } : a));

                    if (!res.data.calisiyor) {
                        clearInterval(intervalRefs.current[idx]);
                        setAdim(idx, { calisiyor: false, ilerleme: 100 });

                        if (res.data.sonuc) {
                            const sonuc = res.data.sonuc;
                            const hisseler = hisselerdenCikar(sonuc, adim.modul);
                            setAdimlar(prev => {
                                const yeni = [...prev];
                                yeni[idx] = { ...yeni[idx], sonuc, calisiyor: false, ilerleme: 100 };
                                if (hisseler.length > 0 && idx === yeni.length - 1 && yeni.length < MODULLER.length) {
                                    const sonrakiModul = MODULLER.find(m => !yeni.map(a => a.modul).includes(m)) || MODULLER[0];
                                    yeni.push({ modul: sonrakiModul, filtre: defaultFiltreler(sonrakiModul, piyasa), sonuc: null, calisiyor: false, ilerleme: 0, mesaj: "", bulunan:0, tamamlanan:0, toplam:0, periyotlar:[] });
                                }
                                return yeni;
                            });
                            toast.success(`${adim.modul}: ${hisseler.length} hisse bulundu`);
                        } else if (res.data.hata) {
                            toast.error(`${adim.modul}: ${res.data.hata}`);
                            setAdim(idx, { calisiyor: false });
                        }
                    }
                } catch { clearInterval(intervalRefs.current[idx]); setAdim(idx, { calisiyor: false }); }
            }, 3000);
		} catch (e) {
			const detail = e.response?.data?.detail;
			const mesaj = typeof detail === "string"
				? detail
				: Array.isArray(detail)
					? detail.map(d => `${d.loc?.join(".")}: ${d.msg}`).join(" | ")
					: "Hata oluştu";
			toast.error(mesaj);
			console.error("Payload hatası:", e.response?.data);
			setAdim(idx, { calisiyor: false });
		}
    };

    useEffect(() => {
        return () => Object.values(intervalRefs.current).forEach(clearInterval);
    }, []);

    // Tüm adımların kesişim hisseleri
    const kesisimHisseleri = () => {
		const tamamlananlar = adimlar.filter(a => hisselerdenCikar(a.sonuc, a.modul).length > 0);
        if (tamamlananlar.length === 0) return [];
        const sets = tamamlananlar.map(a => new Set(hisselerdenCikar(a.sonuc, a.modul)));
        return [...sets[0]].filter(h => sets.every(s => s.has(h)));
    };

    const gecmisSimAc = () => {
        if (secilenler.size === 0) { toast.error("Önce hisse seçin"); return; }
        setIslemMenuAcik(false);
        setGecmisPopupAdim("kriter");
    };

    const gecmisSimOnay = () => {
        const hisseler = [...secilenler];
        // İlk tamamlanan adımın modülünü ve parametrelerini al
        const ilkAdim  = adimlar.find(a => a.sonuc);
        if (!ilkAdim) return;

        const KAYNAK_MAP = {
            "Dip Tarama":                      "dip_tarama",
            "Likidite Tarama":                 "likidite",
            "FVG Tarama":                      "fvg",
            "Çapa Noktası Tarama":             "capa",
            "MSB Tarama":                      "msb",
            "OTE Tarama":                      "ote",
            "OB & BB Tarama":                  "obbb",
            "IDM Tarama":                      "idm",
            "P/D Zone Tarama":                 "pd",
            "SMT Tarama":  "smt",
            "Killzone Tarama":                 "killzone",
        };

        const payload   = buildPayload(ilkAdim.modul, ilkAdim.filtre, piyasa, paraBirimi, null);
        const kaynak    = KAYNAK_MAP[ilkAdim.modul] || "dip_tarama";

        // payload içindeki hisse_listesi: null, ...payload spread'inden sonra
        // hisse_listesi: hisseler'i ezmesin diye payload'dan çıkarıyoruz
        const { hisse_listesi: _ignored, mod: _mod, para_birimi: _pb, ...payloadRest } = payload;

        navigate("/gecmis-simulasyon", { state: {
            kaynak,
            kaynak_label:  `Çoklu Tarama (${ilkAdim.modul})`,
            mod:           piyasa,
            para_birimi:   paraBirimi || "USD",
            sim_tarihi:    gecmisSimTarihi,
            ref_fiyat:     gecmisRefFiyat,
            hisse_listesi: hisseler,
            oto_baslat:    true,
            ...payloadRest,
        }});
        setGecmisPopupAdim(null);
    };

    const dogrulukKaydet = async () => {
        if (secilenler.size === 0) { toast.error("Önce hisse seçin"); return; }
        setDogrulukKaydediliyor(true);
        setDogrulukPopup("yukleniyor");
        setIslemMenuAcik(false);
        try {
            const token = await getToken();
            const modullerStr = adimlar.filter(a => a.sonuc).map(a => a.modul).join(", ");
            const ilkAdim = adimlar.find(a => a.sonuc);
            const fiyatMap = {};
            if (ilkAdim) {
                const kayitlar = ilkAdim.sonuc?.dip || ilkAdim.sonuc?.sonuclar || [];
                kayitlar.forEach(r => {
                    const sym = r["Hisse"] || r["hisse"] || r["symbol"] || "";
                    if (sym) fiyatMap[sym] = r["Fiyat"] || r["fiyat"] || null;
                });
            }
            const hisseler = [...secilenler].map(h => ({ hisse: h, fiyat: fiyatMap[h] || null }));
            const res = await axios.post(`${API_URL}/scan/coklu-tarama-analiz/kaydet`, {
                hisseler, mod: piyasa,
                para_birimi: paraBirimi || "USD",
                moduller: modullerStr,
            }, { headers: { Authorization: `Bearer ${token}` } });
            setDogrulukSonuc(res.data);
            setDogrulukPopup("tamam");
        } catch (e) {
            toast.error("Kaydedilemedi: " + (e.response?.data?.detail || e.message));
            setDogrulukPopup(null);
        }
        finally { setDogrulukKaydediliyor(false); }
    };

    const alarmAc = () => {
        if (secilenler.size === 0) { toast.error("Önce hisse seçin"); return; }
        const ilkAdim = adimlar.find(a => a.sonuc);
        const fiyatMap = {};
        if (ilkAdim) {
            const kayitlar = ilkAdim.sonuc?.dip || ilkAdim.sonuc?.sonuclar || [];
            kayitlar.forEach(r => {
                const sym = r["Hisse"] || r["hisse"] || r["symbol"] || "";
                if (sym) fiyatMap[sym] = r["Fiyat"] || r["fiyat"] || null;
            });
        }
        setAlarmHisseler([...secilenler].map(h => ({ hisse: h, fiyat: fiyatMap[h] || 0 })));
        setHedefFiyatlar({}); setAlarmMail(false); setAlarmBildirim(true);
        setAlarmPopup(true); setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik = alarmHisseler.find(h => !hedefFiyatlar[h.hisse] || isNaN(parseFloat(hedefFiyatlar[h.hisse])));
        if (eksik) { toast.error(`${eksik.hisse} için hedef fiyat girin`); return; }
        setAlarmKaydediliyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            for (const h of alarmHisseler) {
                const fiyat = parseFloat(h.fiyat), hedef = parseFloat(hedefFiyatlar[h.hisse]);
                const pot = fiyat > 0 ? ((hedef-fiyat)/fiyat*100).toFixed(2) : null;
                const { error } = await supabase.from("alerts").insert({
                    piyasa, sembol: h.hisse, para_birimi: paraBirimi||"USD",
                    fiyat, hedef_fiyat: hedef, potansiyel: pot ? parseFloat(pot) : null,
                    bildirim_mail: alarmMail, bildirim_popup: alarmBildirim, user_id: session.user.id,
                });
                if (error) throw error;
            }
            toast.success(`${alarmHisseler.length} alarm eklendi!`);
            setAlarmPopup(false); setAlarmHisseler([]);
        } catch (e) { toast.error("Alarm kaydedilemedi: " + e.message); }
        finally { setAlarmKaydediliyor(false); }
    };


    const kesisim = kesisimHisseleri();
    const tamamlananAdimSayisi = adimlar.filter(a => a.sonuc).length;

    return (
        <div style={{padding:24,background:C.bg,minHeight:"100vh",color:C.text,fontFamily:"system-ui,sans-serif"}}>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                <span style={{fontSize:32}}>🔗</span>
                <div>
                    <h1 style={{margin:0,fontSize:22,fontWeight:800,color:C.text}}>Çoklu Tarama</h1>
                    <p style={{margin:0,fontSize:13,color:C.muted}}>Birden fazla tarama modülünü art arda uygula — her adım bir öncekinin sonucunu filtreler.</p>
                </div>
            </div>

            {/* Birinci filtre satırı — Piyasa + Para Birimi + Kriter seçimleri */}
            <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:12,padding:"16px 20px",marginBottom:16,display:"flex",gap:12,flexWrap:"wrap",alignItems:"flex-end"}}>
                {(() => {
                    const taramaBasladi = adimlar.some(a => a.sonuc || a.calisiyor);
                    return (<>
                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:taramaBasladi?0.5:1,pointerEvents:taramaBasladi?"none":"auto"}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PİYASA {taramaBasladi&&<span style={{fontSize:10,color:C.muted}}>🔒</span>}</legend>
                    <div style={{display:"flex",gap:6}}>
                        {piyasaSecenekleri.map(p=>(<button key={p} onClick={()=>handlePiyasaDegis(p)} style={{padding:"5px 14px",borderRadius:6,fontWeight:600,fontSize:13,cursor:"pointer",border:`2px solid ${piyasa===p?C.accent:C.border}`,background:piyasa===p?C.accent+"22":"transparent",color:piyasa===p?C.accent:C.muted}}>{p}</button>))}
                    </div>
                </fieldset>

                <fieldset style={{border:`1px solid ${C.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:taramaBasladi?0.5:1,pointerEvents:taramaBasladi?"none":"auto"}}>
                    <legend style={{fontSize:11,color:C.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PARA BİRİMİ {taramaBasladi&&<span style={{fontSize:10,color:C.muted}}>🔒</span>}</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {paraBirimiSecenekleri.map(p=>(<button key={p} onClick={()=>setParaBirimi(p)} style={{padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",border:`2px solid ${paraBirimi===p?"#a78bfa":C.border}`,background:paraBirimi===p?"#a78bfa22":"transparent",color:paraBirimi===p?"#a78bfa":C.muted}}>{p}</button>))}
                    </div>
                </fieldset>
                    </>);
                })()}

                <div style={{ borderLeft: `1px solid ${C.border}`, margin: "0 0.5rem" }} />

                {adimlar.map((adim, idx) => (
                    <div key={idx} style={styles.filtreGrup}>
                        <label style={{...styles.etiket, display:"flex", alignItems:"center", gap:4}}>
                            {["BİRİNCİ","İKİNCİ","ÜÇÜNCÜ","DÖRDÜNCÜ","BEŞİNCİ"][idx] ? `${["BİRİNCİ","İKİNCİ","ÜÇÜNCÜ","DÖRDÜNCÜ","BEŞİNCİ"][idx]} KRİTER` : `${idx + 1}. KRİTER`}
                            {adim.sonuc && <span style={{fontSize:10,color:C.muted}}>🔒</span>}
                        </label>
                        <select
                            style={{ background:C.bg, color: adim.sonuc ? C.muted : C.text, border:`1px solid ${adim.sonuc ? C.border : (ADIM_RENKLER[idx]||C.border)}`, borderRadius:8, padding:"7px 10px", fontSize:13, cursor: adim.sonuc ? "not-allowed" : "pointer", outline:"none", minWidth:110, opacity: adim.sonuc ? 0.5 : 1 }}
                            value={adim.modul}
                            onChange={e => modulDegis(idx, e.target.value)}
                            disabled={adim.sonuc || (idx > 0 && !adimlar[idx - 1].sonuc)}
                        >
                            {MODULLER.filter(m => !adimlar.slice(0, idx).map(a => a.modul).includes(m)).map(m => <option key={m}>{m}</option>)}
                        </select>
                    </div>
                ))}
                <div style={{borderLeft:`1px solid ${C.border}`,margin:"0 0.5rem"}}/>
                <button onClick={()=>{
                    setAdimlar([{modul:"Dip Tarama",filtre:defaultFiltreler("Dip Tarama",piyasa),sonuc:null,calisiyor:false,ilerleme:0,mesaj:"",bulunan:0,tamamlanan:0,toplam:0,periyotlar:[]}]);
                    setSecilenler(new Set()); setIslemMenuAcik(false);
                    periyotlariYukle([{modul:"Dip Tarama",filtre:defaultFiltreler("Dip Tarama",piyasa),periyotlar:[]}]);
                }} style={{padding:"7px 18px",borderRadius:8,border:`1px solid ${C.bearish||"#dc2626"}66`,background:"#dc262611",color:"#dc2626",cursor:"pointer",fontSize:13,fontWeight:600,alignSelf:"flex-end"}}>
                    🗑 Temizle
                </button>
            </div>

            {/* Her adım için filtre + tarama satırı */}
            {adimlar.map((adim, idx) => {
                const oncekiSonuc = idx > 0 ? adimlar[idx - 1].sonuc : null;
                const oncekiHisseleri = idx > 0 ? hisselerdenCikar(oncekiSonuc, adimlar[idx - 1].modul) : null;
                const pasif = idx > 0 && (!oncekiSonuc || oncekiHisseleri?.length === 0);

                const herhangiCalisiyor = adimlar.some(a => a.calisiyor);
                const sonrakiAcilacakIdx = adimlar.findIndex((a, i) => !a.sonuc && !a.calisiyor && (i === 0 || adimlar[i-1].sonuc));
                const kontrolKilitli = pasif || adim.calisiyor ||
                    herhangiCalisiyor ||
                    (adim.sonuc && idx !== sonrakiAcilacakIdx) ||
                    (!adim.sonuc && !adim.calisiyor && idx !== sonrakiAcilacakIdx && adimlar.some(a=>a.sonuc));

                return (
                    <div key={idx} style={{ ...styles.adimKart, borderLeftColor: ADIM_RENKLER[idx] || C.muted, opacity: pasif ? 0.5 : 1 }}>
                        <div style={styles.adimBaslik}>
                            <span style={{ ...styles.adimNo, background: ADIM_RENKLER[idx] || C.muted }}>{idx + 1}</span>
                            <span style={{ fontWeight: "600", fontSize: "14px", color: C.text }}>
                                {adim.modul} Filtreleri
                            </span>
                            {idx > 0 && oncekiHisseleri && (
                                <span style={{ fontSize: 12, color: C.muted, marginLeft: "auto" }}>
                                    ⬅ Önceki taramadan: <strong>{oncekiHisseleri.length}</strong> hisse
                                </span>
                            )}
                        </div>

                        <div style={{...styles.adimFiltreler, opacity: kontrolKilitli && !adim.calisiyor ? 0.5 : 1, pointerEvents: kontrolKilitli ? "none" : "auto"}}>
                            <ModulFiltresi
                                modul={adim.modul}
                                filtre={adim.filtre}
                                onChange={f => filtreGuncelle(idx, f)}
                                piyasa={piyasa}
                                paraBirimi={paraBirimi}
                                periyotlar={adim.periyotlar || PERIYOT_OPTS}
                            />
                            <button
                                onClick={() => taramaBaslat(idx)}
                                disabled={adim.calisiyor || pasif}
                                style={{padding:"10px 24px",borderRadius:8,fontWeight:700,fontSize:13,cursor:adim.calisiyor||pasif?"not-allowed":"pointer",background:adim.calisiyor?"#475569":`linear-gradient(135deg,#1d4ed8,${ADIM_RENKLER[idx]||"#3b82f6"})`,border:"none",color:"white",alignSelf:"flex-end"}}
                            >
                                {adim.calisiyor ? "⏳ Taranıyor..." : "🔍 Tara"}
                            </button>
                        </div>

                        {/* Uyarı + İlerleme */}
                        {adim.calisiyor && (<>
                            <div style={{display:"flex",alignItems:"center",gap:8,marginTop:12,marginBottom:8,padding:"10px 16px",borderRadius:8,background:"#422006",border:"1px solid #92400e"}}>
                                <span style={{fontSize:16}}>⚠️</span>
                                <span style={{fontSize:13,color:"#fde68a",fontWeight:600}}>Tarama tamamlanıncaya kadar sayfayı kapatmayın</span>
                            </div>
                            <IlerlemePanel
                                modul={adim.modul}
                                ilerleme={adim.ilerleme||0}
                                tamamlanan={adim.tamamlanan||0}
                                toplam={adim.toplam||0}
                                bulunan={adim.bulunan||0}
                                baslangic={adim.baslangicZaman}
                                renk={ADIM_RENKLER[idx]||C.accent}
                            />
                        </>)}

                        {/* Sonuç özeti */}
                        {adim.sonuc && (
                            <div style={{marginTop:10,padding:"10px 16px",background:"#052e16",border:`1px solid ${ADIM_RENKLER[idx]||C.bullish}44`,borderRadius:8,display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:13}}>
                                <span style={{color:C.text}}>✅ {adim.modul} tamamlandı</span>
                                <span style={{fontWeight:700,color:ADIM_RENKLER[idx]||C.bullish}}>
                                    {hisselerdenCikar(adim.sonuc, adim.modul).length} hisse bulundu
                                </span>
                            </div>
                        )}
                    </div>
                );
            })}

            {/* Kesişim sonuçları */}
            {tamamlananAdimSayisi >= 1 && (
                <div style={styles.kesisimKart}>
                    <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 20px",marginBottom:16,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
                        <div style={{position:"relative"}}>
                            <button onClick={()=>setIslemMenuAcik(v=>!v)}
                                style={{padding:"6px 16px",borderRadius:8,border:`1px solid ${C.border}`,background:C.panel,cursor:"pointer",fontSize:"13px",fontWeight:500,color:C.text,display:"flex",alignItems:"center",gap:5}}>
                                İşlemler ▾
                            </button>
                            {islemMenuAcik && (
                                <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,background:C.panel,border:`1px solid ${C.border}`,borderRadius:"10px",boxShadow:"0 8px 24px rgba(0,0,0,0.4)",zIndex:100,minWidth:"300px",overflow:"visible"}}>
                                    {[
                                        {label:dogrulukKaydediliyor?"⏳ Kaydediliyor...":"✅ Doğruluk Analizine Gönder",aktif:!dogrulukKaydediliyor,fn:dogrulukKaydet},
                                        {label:"🔮 Geçmiş Simülasyonuna Gönder",aktif:secilenler.size>0,fn:gecmisSimAc},
                                        {label:"🔗 Çoklu Taramaya Gönder",aktif:false,fn:()=>{}},
                                        {label:"🏆 Puanlamaya Gönder",aktif:secilenler.size>0,fn:()=>{
                                            if(secilenler.size===0){toast.error("Önce hisse seçin");return;}
                                            const bistVadeOpts=["Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)"];
                                            setPuanlamaVade(piyasa==="Kripto"?"Kaldıraçlı İşlem":bistVadeOpts[0]);
                                            setPuanlamaYon(new Set(["Long","Short"]));setPuanlamaMinPuan(0);
                                            setPuanlamaPopupAdim("kriter");setIslemMenuAcik(false);
                                        }},
                                        {label:"⏰ Alarm Ekle",aktif:true,fn:alarmAc},
                                        {label:"🔎 İzleme Listesine Ekle",aktif:false,fn:()=>{}},
                                    ].map(item=>(
                                        <button key={item.label} onClick={item.aktif?item.fn:undefined} disabled={!item.aktif}
                                            style={{display:"block",width:"100%",textAlign:"left",padding:"10px 16px",
                                                border:"none",background:"none",fontSize:"13px",borderBottom:`1px solid ${C.border}`,
                                                cursor:item.aktif?"pointer":"default",color:!item.aktif?C.muted:C.text}}>
                                            {item.label}
                                        </button>
                                    ))}
                                    <IndirMenusu veri={kesisim.map(h=>({Hisse:h,Piyasa:piyasa,"Para Birimi":paraBirimi||"USD"}))} setIslemMenuAcik={setIslemMenuAcik}/>
                                </div>
                            )}
                        </div>
                        <div style={{width:1,height:20,background:C.border}}/>
                        <span style={{fontSize:13,color:C.muted,flex:1}}>
                            {(() => {
                                const tamamlananModuller = adimlar.filter(a=>a.sonuc).map(a=>a.modul);
                                if (tamamlananModuller.length === 0) return "";
                                const modulStr = tamamlananModuller.join(", ");
                                return `${modulStr} taramaları sonucunda kriterlere uygun `;
                            })()}
                            <strong style={{color:C.text}}>{kesisim.length}</strong>
                            <span style={{color:C.muted}}> hisse bulundu</span>
                        </span>
                    </div>
                    {kesisim.length > 0 ? (
                        (() => {
                            // Fiyat bilgisini tüm adımların sonuçlarından topla
                            const fiyatMap = {};
                            adimlar.filter(a => a.sonuc).forEach(a => {
                                const kayitlar = a.modul === "Dip Tarama"
                                    ? (a.sonuc?.dip || [])
                                    : (a.sonuc?.sonuclar || []);
                                kayitlar.forEach(r => {
                                    const sym = r["Hisse"] || r["hisse"] || r["symbol"] || "";
                                    if (sym && !fiyatMap[sym]) {
                                        fiyatMap[sym] = r["Fiyat"] || r["fiyat"] || null;
                                    }
                                });
                            });
                            return (
                                <div style={{overflowX:"auto"}}>
                                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:"13px"}}>
                                        <thead>
                                            <tr style={{background:C.bg,borderBottom:`2px solid ${C.border}`}}>
                                                <th style={{width:"40px",padding:"8px 12px",textAlign:"center"}}>
                                                    <button type="button" onClick={() => {
                                                        if (kesisim.every(h => secilenler.has(h))) setSecilenler(new Set());
                                                        else setSecilenler(new Set(kesisim));
                                                    }} style={{width:16,height:16,padding:0,border:`2px solid ${secilenler.size>0&&kesisim.every(h=>secilenler.has(h))?C.accent:C.border}`,borderRadius:3,background:secilenler.size>0&&kesisim.every(h=>secilenler.has(h))?C.accent:"transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white"}}>
                                                        {secilenler.size>0&&kesisim.every(h=>secilenler.has(h))?"✓":""}
                                                    </button>
                                                </th>
                                                <th style={{padding:"8px 16px",textAlign:"left",fontWeight:"600",color:C.muted}}>Hisse</th>
                                                <th style={{padding:"8px 16px",textAlign:"left",fontWeight:"600",color:C.muted}}>Piyasa</th>
                                                <th style={{padding:"8px 16px",textAlign:"left",fontWeight:"600",color:C.muted}}>Para Birimi</th>
                                                <th style={{padding:"8px 16px",textAlign:"right",fontWeight:"600",color:C.muted}}>Fiyat</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {kesisim.map((h, i) => {
                                                const secili = secilenler.has(h);
                                                const fiyat  = fiyatMap[h];
                                                return (
                                                    <tr key={h}
                                                        onClick={() => setSecilenler(prev => {
                                                            const s = new Set(prev);
                                                            s.has(h) ? s.delete(h) : s.add(h);
                                                            return s;
                                                        })}
                                                        style={{
                                                            background: secili ? C.accent+"18" : i % 2 === 0 ? C.panel : C.bg,
                                                            cursor: "pointer",
                                                            borderBottom: `1px solid ${C.border}22`,
                                                        }}>
                                                        <td style={{textAlign:"center",padding:"8px 12px"}}>
                                                            <div style={{width:16,height:16,border:`2px solid ${secili?C.accent:C.border}`,borderRadius:3,background:secili?C.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white",flexShrink:0}}>{secili?"✓":""}</div>
                                                        </td>
                                                        <td style={{padding:"8px 16px",fontWeight:"600",color:C.accent}}>{h}</td>
                                                        <td style={{padding:"8px 16px",color:C.text}}>{piyasa}</td>
                                                        <td style={{padding:"8px 16px",color:C.text}}>{paraBirimi || "USD"}</td>
                                                        <td style={{padding:"8px 16px",textAlign:"right",color:C.text}}>
                                                            {fiyat ?? "—"}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    <div style={{padding:"8px 12px",fontSize:"12px",color:C.muted,borderTop:`1px solid ${C.border}`}}>
                                        {secilenler.size}/{kesisim.length} hisse seçildi
                                    </div>
                                </div>
                            );
                        })()
                    ) : (
                        <div style={{ color: C.muted, fontSize: 14, padding: "0.75rem 0" }}>
                            Tüm kriterlerin kesişiminde hisse bulunamadı.
                        </div>
                    )}
                </div>
            )}
            {/* ── Puanlamaya Gönder Popup: Kriter ──────────── */}
            {puanlamaPopupAdim === "kriter" && (() => {
                const bistVadeOpts   = ["Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)"];
                const kriptoVadeOpts = ["Kaldıraçlı İşlem", "Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)"];
                const vadeOpts    = piyasa === "Kripto" ? kriptoVadeOpts : bistVadeOpts;
                const kaldırac    = puanlamaVade === "Kaldıraçlı İşlem";
                const paraB       = piyasa === "BIST" ? paraBirimi : "USD";
                const minPuanOpts = [0, 25, 50, 60, 75];
                const toggleYon   = (y) => setPuanlamaYon(prev => {
                    const next = new Set(prev);
                    if (next.has(y)) { if (next.size === 1) return prev; next.delete(y); }
                    else next.add(y);
                    return next;
                });
                return (
                    <div style={overlayStyle}>
                        <div style={{...modalStyle, width:"420px"}}>
                            <div style={{fontSize:"18px",fontWeight:"700",color:C.accent,marginBottom:"0.75rem"}}>🏆 Puanlamaya Gönder</div>
                            <p style={{fontSize:"13px", color:C.muted, marginBottom:"1.25rem"}}>
                                <strong>{secilenler.size}</strong> hisse seçildi. Puanlama kriterlerini belirleyin.
                            </p>
                            <div style={{display:"flex", gap:"8px", marginBottom:"1.25rem"}}>
                                {[["Piyasa", piyasa], ["Para Birimi", paraB]].map(([etiket, deger]) => (
                                    <div key={etiket} style={{flex:1, background:"#f8fafc", border:"1px solid #e5e7eb",
                                                               borderRadius:"8px", padding:"10px 14px"}}>
                                        <div style={{fontSize:"11px", color:C.muted, fontWeight:"500", marginBottom:"2px"}}>{etiket} (kilitli)</div>
                                        <div style={{fontSize:"14px", fontWeight:"600", color:C.text}}>🔒 {deger}</div>
                                    </div>
                                ))}
                            </div>
                            <div style={{marginBottom:"1.25rem"}}>
                                <label style={{fontSize:"12px", fontWeight:"600", color:C.text, display:"block", marginBottom:"6px"}}>📅 Vade</label>
                                <select value={puanlamaVade || ""} onChange={e => setPuanlamaVade(e.target.value)}
                                    style={{width:"100%", padding:"9px 12px", borderRadius:"8px", border:"1px solid #d1d5db",
                                            fontSize:"13px", background:C.panel, color:C.text, cursor:"pointer"}}>
                                    {vadeOpts.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                            </div>
                            {kaldırac && (
                                <div style={{marginBottom:"1.25rem"}}>
                                    <div style={{fontSize:"12px", fontWeight:"600", color:C.text, marginBottom:"8px"}}>📈 İşlem Yönü</div>
                                    <div style={{display:"flex", gap:"8px"}}>
                                        {["Long", "Short"].map(y => (
                                            <button key={y} type="button" onClick={() => toggleYon(y)}
                                                style={{flex:1, padding:"10px", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600",
                                                        border: puanlamaYon.has(y) ? "2px solid #1e3a5f" : "2px solid #e5e7eb",
                                                        background: puanlamaYon.has(y) ? (y==="Long" ? "#dcfce7" : "#fee2e2") : C.panel,
                                                        color: puanlamaYon.has(y) ? (y==="Long" ? "#16a34a" : "#dc2626") : C.muted}}>
                                                {y === "Long" ? "📈 Long" : "📉 Short"}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div style={{marginBottom:"1.5rem"}}>
                                <label style={{fontSize:"12px", fontWeight:"600", color:C.text, display:"block", marginBottom:"8px"}}>🎯 Minimum Puan</label>
                                <div style={{display:"flex", gap:"6px"}}>
                                    {minPuanOpts.map(p => (
                                        <button key={p} type="button" onClick={() => setPuanlamaMinPuan(p)}
                                            style={{flex:1, padding:"8px 4px", borderRadius:"8px", cursor:"pointer",
                                                    fontSize:"13px", fontWeight: puanlamaMinPuan === p ? "700" : "400",
                                                    border: puanlamaMinPuan === p ? "2px solid #1e3a5f" : "2px solid #e5e7eb",
                                                    background: puanlamaMinPuan === p ? C.accent : C.panel,
                                                    color: puanlamaMinPuan === p ? C.panel : C.text}}>
                                            {p === 0 ? "0+" : `${p}+`}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div style={{display:"flex", gap:"8px", justifyContent:"flex-end"}}>
                                <button onClick={() => setPuanlamaPopupAdim(null)} style={btnVazgecStyle}>İptal</button>
                                <button onClick={() => setPuanlamaPopupAdim("onay")} style={btnPrimaryStyle}>Devam Et →</button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ── Puanlamaya Gönder Popup: Onay ───────────── */}
            {puanlamaPopupAdim === "onay" && (
                <div style={overlayStyle}>
                    <div style={{...modalStyle, width:"420px"}}>
                        <div style={{fontSize:"18px",fontWeight:"700",color:C.accent,marginBottom:"0.75rem"}}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{background:"#422006", border:"1px solid #fde68a", borderRadius:"8px",
                                     padding:"1rem", marginBottom:"1.25rem", fontSize:"13px", color:"#fde68a", lineHeight:"1.7"}}>
                            Başka bir sayfaya yönlendiriliyorsunuz. <strong>Ekrandaki tarama sonuçları kaybolacak.</strong>
                            <br /><br />
                            Seçili <strong>{secilenler.size} hisse</strong> için <strong>Puanlama ve Tahmin</strong> taraması
                            otomatik olarak başlatılacaktır. Emin misiniz?
                        </div>
                        <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px", marginBottom:"1.25rem", fontSize:"12px"}}>
                            {[
                                ["Piyasa",       piyasa],
                                ["Para Birimi",  piyasa === "BIST" ? paraBirimi : "USD"],
                                ["Vade",         puanlamaVade],
                                ...(puanlamaVade === "Kaldıraçlı İşlem" ? [["İşlem Yönü", [...puanlamaYon].join(" & ")]] : []),
                                ["Min Puan",     puanlamaMinPuan === 0 ? "0+ (Tümü)" : `${puanlamaMinPuan}+`],
                                ["Hisse Sayısı", `${secilenler.size} hisse`],
                            ].map(([k, v]) => (
                                <div key={k} style={{display:"flex", justifyContent:"space-between",
                                                     background:C.bg, borderRadius:"6px", padding:"6px 10px"}}>
                                    <span style={{color:C.muted}}>{k}:</span>
                                    <strong style={{color:C.accent}}>{v}</strong>
                                </div>
                            ))}
                        </div>
                        <div style={{display:"flex", gap:"8px", justifyContent:"flex-end"}}>
                            <button onClick={() => setPuanlamaPopupAdim("kriter")} style={btnVazgecStyle}>← Geri</button>
                            <button onClick={() => setPuanlamaPopupAdim(null)} style={btnVazgecStyle}>Hayır, İptal</button>
                            <button onClick={() => {
                                const hisseListesi = [...secilenler];
                                setPuanlamaPopupAdim(null);
                                navigate("/puanlama-tahmin", {
                                    state: {
                                        kaynak:        "coklu_tarama",
                                        piyasa,
                                        para_birimi:   piyasa === "BIST" ? paraBirimi : "USD",
                                        vade:          puanlamaVade,
                                        islem_yonu:    [...puanlamaYon].join(","),
                                        min_puan:      puanlamaMinPuan,
                                        hisse_listesi: hisseListesi,
                                        oto_baslat:    true,
                                    }
                                });
                            }} style={btnPrimaryStyle}>
                                Evet, Başlat 🚀
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {gecmisPopupAdim === "kriter" && (
                <div style={overlayStyle}>
                    <div style={{...modalStyle, width:"420px"}}>
                        <div style={modalBaslikStyle}>🔮 Geçmiş Simülasyonu</div>
                        <p style={{fontSize:"13px", color:C.muted, marginBottom:"1.25rem"}}>
                            <strong>{secilenler.size}</strong> hisse seçildi. Simülasyon kriterlerini belirleyin.
                        </p>
                        <div style={{display:"flex", flexDirection:"column", gap:"1rem", marginBottom:"1.25rem"}}>
                            <div>
                                <label style={{fontSize:"12px", fontWeight:"600", color:C.text, display:"block", marginBottom:"6px"}}>📅 Simülasyon Tarihi</label>
                                <MiniTakvim value={gecmisSimTarihi} onChange={setGecmisSimTarihi} />
                            </div>
                            <div>
                                <label style={{fontSize:"12px", fontWeight:"600", color:C.text, display:"block", marginBottom:"6px"}}>💱 Referans Fiyat</label>
                                <div style={{display:"flex", gap:"8px"}}>
                                    {["Bugünkü", "En Yüksek"].map(opt => (
                                        <button key={opt} type="button" onClick={() => setGecmisRefFiyat(opt)} style={{
                                            flex:1, padding:"10px", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"500",
                                            border: gecmisRefFiyat === opt ? "2px solid #7c3aed" : "2px solid #e5e7eb",
                                            background: gecmisRefFiyat === opt ? "#7c3aed" : C.panel,
                                            color: gecmisRefFiyat === opt ? C.panel : C.text}}>
                                            {opt === "Bugünkü" ? "📅 Bugünkü Fiyat" : "🏆 En Yüksek Fiyat"}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div style={{background:"#f0f9ff",border:"1px solid #bae6fd",borderRadius:"8px",padding:"10px 14px",
                            marginBottom:"1.25rem",fontSize:"12px",color:"#0c4a6e"}}>
                            <strong>📌 Not:</strong> Simülasyon, ilk tarama adımının ({adimlar.find(a=>a.sonuc)?.modul || "?"}) kriterleriyle çalışacaktır.
                        </div>
                        <div style={{display:"flex", gap:"8px", justifyContent:"flex-end"}}>
                            <button onClick={() => setGecmisPopupAdim(null)} style={btnVazgecStyle}>İptal</button>
                            <button onClick={() => { if (!gecmisSimTarihi) return; setGecmisPopupAdim("onay"); }} style={btnPrimaryStyle}>Devam Et →</button>
                        </div>
                    </div>
                </div>
            )}

            {gecmisPopupAdim === "onay" && (
                <div style={overlayStyle}>
                    <div style={modalStyle}>
                        <div style={modalBaslikStyle}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                        <div style={{background:"#422006",border:"1px solid #fde68a",borderRadius:"8px",padding:"1rem",
                            marginBottom:"1.25rem",fontSize:"13px",color:"#fde68a",lineHeight:"1.7"}}>
                            Bu sayfa temizlenerek <strong>Geçmiş Simülasyon</strong> sayfasına yönlendirileceksiniz.
                            <br/><br/>Devam etmek istiyor musunuz?
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"1.25rem",fontSize:"12px"}}>
                            {[
                                ["Piyasa",            piyasa],
                                ["Modül",             adimlar.find(a=>a.sonuc)?.modul || "—"],
                                ["Hisse Sayısı",      `${secilenler.size} hisse`],
                                ["Simülasyon Tarihi", (() => { const d = new Date(gecmisSimTarihi+"T00:00:00"); return d.toLocaleDateString("tr-TR",{day:"2-digit",month:"long",year:"numeric"}); })()],
                                ["Referans Fiyat",    gecmisRefFiyat],
                            ].map(([k,v]) => (
                                <div key={k} style={{display:"flex",justifyContent:"space-between",background:C.bg,borderRadius:"6px",padding:"6px 10px"}}>
                                    <span style={{color:C.muted}}>{k}:</span>
                                    <strong style={{color:C.accent}}>{v}</strong>
                                </div>
                            ))}
                        </div>
                        <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}>
                            <button onClick={() => setGecmisPopupAdim("kriter")} style={btnVazgecStyle}>← Geri</button>
                            <button onClick={() => setGecmisPopupAdim(null)} style={btnVazgecStyle}>Hayır, İptal</button>
                            <button onClick={gecmisSimOnay} style={btnPrimaryStyle}>Evet, Başlat 🚀</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Doğruluk Analizi Popup */}
            {dogrulukPopup && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000}}>
                    <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:14,padding:"2rem",width:420,maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)"}}>
                        {dogrulukPopup === "yukleniyor" ? (
                            <><div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}><span style={{fontSize:24}}>✅</span><div><div style={{fontSize:16,fontWeight:700,color:C.text}}>Doğruluk Analizi</div><div style={{fontSize:12,color:C.muted,marginTop:2}}>Veriler kaydediliyor...</div></div></div><HareketliBar/><div style={{fontSize:13,color:C.muted,textAlign:"center"}}>Kaydediliyor...</div></>
                        ) : (
                            <><div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}><span style={{fontSize:28}}>✅</span><div style={{fontSize:16,fontWeight:700,color:C.text}}>Kayıt Tamamlandı</div></div>
                            <div style={{background:C.bullish+"22",border:`1px solid ${C.bullish}44`,borderRadius:8,padding:"14px 16px",marginBottom:20,fontSize:14,color:C.bullish,lineHeight:1.6}}>
                                Seçilen hisseler <strong>"Doğruluk Analizi"</strong> veri tabanına kaydedildi.
                                {dogrulukSonuc && (<div style={{marginTop:8,fontSize:12,color:C.muted}}>{dogrulukSonuc.toplam ? <span>✔ {dogrulukSonuc.toplam} kayıt işleme alındı</span> : dogrulukSonuc.eklenen != null && <span>✔ {dogrulukSonuc.eklenen} yeni · {dogrulukSonuc.atlanan} mevcut</span>}</div>)}
                            </div>
                            <div style={{display:"flex",justifyContent:"flex-end"}}><button onClick={()=>{setDogrulukPopup(null);setDogrulukSonuc(null);}} style={{padding:"8px 28px",borderRadius:8,border:"none",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"white",cursor:"pointer",fontSize:14,fontWeight:600}}>Tamam</button></div></>
                        )}
                    </div>
                </div>
            )}


            {/* Puanlama Kriter Popup */}
            {puanlamaPopupAdim==="kriter"&&(()=>{
                const bistOpts=["Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)"];
                const vadeOpts=piyasa==="Kripto"?["Kaldıraçlı İşlem",...bistOpts]:bistOpts;
                const kaldırac=puanlamaVade==="Kaldıraçlı İşlem";
                const paraB=piyasa==="BIST"?paraBirimi:"USD";
                const toggleYon=y=>setPuanlamaYon(prev=>{const n=new Set(prev);if(n.has(y)){if(n.size===1)return prev;n.delete(y);}else n.add(y);return n;});
                return(<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}><div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"2rem",width:"420px",maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"}}>
                    <div style={{fontSize:"18px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.75rem"}}>🏆 Puanlamaya Gönder</div>
                    <p style={{fontSize:"13px",color:"#94a3b8",marginBottom:"1.25rem"}}><strong>{secilenler.size}</strong> hisse seçildi.</p>
                    <div style={{display:"flex",gap:"8px",marginBottom:"1.25rem"}}>{[["Piyasa",piyasa],["Para Birimi",paraB]].map(([et,d])=>(<div key={et} style={{flex:1,background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",padding:"10px 14px"}}><div style={{fontSize:"11px",color:"#64748b",marginBottom:"2px"}}>{et} (kilitli)</div><div style={{fontSize:"14px",fontWeight:"600",color:"#e2e8f0"}}>🔒 {d}</div></div>))}</div>
                    <div style={{marginBottom:"1.25rem"}}><label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"6px"}}>📅 Vade</label><select value={puanlamaVade||""} onChange={e=>setPuanlamaVade(e.target.value)} style={{width:"100%",padding:"9px 12px",borderRadius:"8px",border:"1px solid #334155",fontSize:"13px",background:"#0f172a",color:"#e2e8f0",cursor:"pointer"}}>{vadeOpts.map(o=><option key={o} value={o}>{o}</option>)}</select></div>
                    {kaldırac&&(<div style={{marginBottom:"1.25rem"}}><div style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",marginBottom:"8px"}}>📈 İşlem Yönü</div><div style={{display:"flex",gap:"8px"}}>{["Long","Short"].map(y=>(<button key={y} type="button" onClick={()=>toggleYon(y)} style={{flex:1,padding:"10px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:"600",border:puanlamaYon.has(y)?"2px solid #3b82f6":"2px solid #334155",background:puanlamaYon.has(y)?(y==="Long"?"#052e16":"#450a0a"):"transparent",color:puanlamaYon.has(y)?(y==="Long"?"#4ade80":"#f87171"):"#64748b"}}>{y==="Long"?"📈 Long":"📉 Short"}</button>))}</div></div>)}
                    <div style={{marginBottom:"1.5rem"}}><label style={{fontSize:"12px",fontWeight:"600",color:"#93c5fd",display:"block",marginBottom:"8px"}}>🎯 Minimum Puan</label><div style={{display:"flex",gap:"6px"}}>{[0,25,50,60,75].map(p=>(<button key={p} type="button" onClick={()=>setPuanlamaMinPuan(p)} style={{flex:1,padding:"8px 4px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:puanlamaMinPuan===p?"700":"400",border:puanlamaMinPuan===p?"2px solid #3b82f6":"2px solid #334155",background:puanlamaMinPuan===p?"#2563eb":"transparent",color:puanlamaMinPuan===p?C.panel:"#e2e8f0"}}>{p===0?"0+":`${p}+`}</button>))}</div></div>
                    <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}><button onClick={()=>setPuanlamaPopupAdim(null)} style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>İptal</button><button onClick={()=>setPuanlamaPopupAdim("onay")} style={{padding:"8px 20px",borderRadius:"8px",border:"none",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:C.panel,cursor:"pointer",fontSize:"13px",fontWeight:"600"}}>Devam Et →</button></div>
                </div></div>);
            })()}

            {puanlamaPopupAdim==="onay"&&(<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}><div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:"14px",padding:"2rem",width:"440px",maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)",color:"#e2e8f0"}}>
                <div style={{fontSize:"18px",fontWeight:"700",color:"#e2e8f0",marginBottom:"0.75rem"}}>⚠️ Sayfadan Ayrılıyorsunuz</div>
                <div style={{background:"#422006",border:"1px solid #92400e",borderRadius:"8px",padding:"1rem",marginBottom:"1.25rem",fontSize:"13px",color:"#fde68a",lineHeight:"1.7"}}>Başka bir sayfaya yönlendiriliyorsunuz. <strong>Ekrandaki tarama sonuçları kaybolacak.</strong></div>
                <div style={{display:"flex",gap:"8px",justifyContent:"flex-end"}}><button onClick={()=>setPuanlamaPopupAdim("kriter")} style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>← Geri</button><button onClick={()=>setPuanlamaPopupAdim(null)} style={{padding:"8px 18px",borderRadius:"8px",border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:"13px",color:"#94a3b8"}}>Hayır, İptal</button><button onClick={()=>{const hl=[...secilenler];setPuanlamaPopupAdim(null);navigate("/puanlama-tahmin",{state:{kaynak:"coklu_tarama",piyasa,para_birimi:paraBirimi||"USD",vade:puanlamaVade,islem_yonu:[...puanlamaYon].join(","),min_puan:puanlamaMinPuan,hisse_listesi:hl,oto_baslat:true}});}} style={{padding:"8px 20px",borderRadius:"8px",border:"none",background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:C.panel,cursor:"pointer",fontSize:"13px",fontWeight:"600"}}>Evet, Başlat 🚀</button></div>
            </div></div>)}


            {alarmPopup && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
                    <div style={{background:C.panel,borderRadius:"12px",padding:"1.5rem",width:"420px",maxHeight:"80vh",overflowY:"auto",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
                        <h3 style={{margin:"0 0 0.75rem",fontSize:"16px",color:C.accent}}>⏰ Alarm Ekle</h3>
                        <div style={{display:"flex",flexDirection:"column",gap:10}}>
                            {alarmHisseler.map(h => {
                                const hedef=hedefFiyatlar[h.hisse]||"",fiyat=parseFloat(h.fiyat),hedefN=parseFloat(hedef);
                                const pct=hedef&&!isNaN(hedefN)&&fiyat>0?((hedefN-fiyat)/fiyat*100).toFixed(2):null;
                                return (
                                    <div key={h.hisse} style={{background:"#f8fafc",borderRadius:8,padding:"10px 12px",border:"1px solid #e5e7eb"}}>
                                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                                            <strong style={{fontSize:14}}>{h.hisse}</strong>
                                            <span style={{color:C.muted,fontSize:12}}>Güncel: {h.fiyat}</span>
                                        </div>
                                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                                            <span style={{color:C.muted,fontSize:12,minWidth:80}}>Hedef Fiyat:</span>
                                            <input type="number" value={hedef} onChange={e=>setHedefFiyatlar(prev=>({...prev,[h.hisse]:e.target.value}))}
                                                style={{flex:1,padding:"4px 8px",borderRadius:6,border:"1px solid #d1d5db",fontSize:13,textAlign:"right"}} placeholder="0.00"/>
                                            {pct!==null&&<span style={{fontSize:12,fontWeight:600,minWidth:52,color:parseFloat(pct)>=0?"#16a34a":"#dc2626"}}>{parseFloat(pct)>=0?"+":""}{pct}%</span>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{marginTop:12}}>
                            <div style={{color:C.muted,marginBottom:6,fontSize:12}}>Bildirim Tercihi:</div>
                            <div style={{display:"flex",gap:16}}>
                                {[["Mail",alarmMail,setAlarmMail],["Pop-up",alarmBildirim,setAlarmBildirim]].map(([ad,val,setter])=>(
                                    <label key={ad} style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:13}}>
                                        <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)}/> {ad}
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div style={{display:"flex",gap:8,marginTop:"1.25rem",justifyContent:"flex-end"}}>
                            <button onClick={()=>{setAlarmPopup(false);setAlarmHisseler([]);}} style={{padding:"6px 16px",borderRadius:8,border:"1px solid #d1d5db",background:C.panel,cursor:"pointer",fontSize:13}}>Vazgeç</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor} style={{padding:"6px 16px",borderRadius:8,border:"none",background:alarmKaydediliyor?C.muted:C.accent,color:C.panel,cursor:"pointer",fontSize:13}}>
                                {alarmKaydediliyor?"Kaydediliyor...":"Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {islemMenuAcik&&<div style={{position:"fixed",inset:0,zIndex:50}} onClick={()=>setIslemMenuAcik(false)}/>}
        </div>
    );
}

const ADIM_RENKLER = ["#2563eb", "#7c3aed", "#059669", "#dc2626", "#d97706", "#0891b2", "#7c2d12", "#6d28d9", "#0369a1", "#0f766e", "#be185d"];

const styles = {
    sayfa:        { padding: "1.5rem" },
    baslik:       { marginBottom: "0.25rem", fontSize: "20px" },
    altBaslik:    { color: C.muted, fontSize: "13px", marginBottom: "1.25rem" },
    filtreSatiri: { display: "flex", gap: "0.75rem", alignItems: "flex-end", flexWrap: "wrap",
                    background: C.panel, padding: "1rem 1.25rem", borderRadius: "12px",
                    marginBottom: "1rem", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    filtreGrup:   { display: "flex", flexDirection: "column", gap: "4px" },
    etiket:       { fontSize: "11px", color: C.muted, fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.03em" },
    select:       { padding: "0.45rem 0.65rem", borderRadius: "8px", border: `1.5px solid ${C.border}`,
                    fontSize: "13px", minWidth: "110px", cursor: "pointer" },
    buton:        { padding: "0.5rem 1.1rem", color: C.panel, border: "none", borderRadius: "8px",
                    cursor: "pointer", fontSize: "13px", fontWeight: "600" },
    adimKart:     { background: C.panel, borderRadius: "12px", padding: "1rem 1.25rem",
                    marginBottom: "0.75rem", boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                    borderLeft: "4px solid" },
    adimBaslik:   { display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.75rem" },
    adimNo:       { width: "22px", height: "22px", borderRadius: "50%", color: C.panel,
                    fontSize: "11px", fontWeight: "700", display: "flex", alignItems: "center",
                    justifyContent: "center", flexShrink: 0 },
    adimFiltreler:{ display: "flex", gap: "0.75rem", flexWrap: "wrap", alignItems: "flex-end" },
    oncekiBilgi:  { marginLeft: "auto", fontSize: "12px", color: C.muted, background: "#f3f4f6",
                    padding: "2px 8px", borderRadius: "99px" },
    ilerlemeKutu: { marginTop: "0.75rem", padding: "0.5rem 0.75rem", background: C.bg, borderRadius: "8px" },
    ilerlemeArk:  { background: `${C.border}`, borderRadius: "99px", height: "8px", overflow: "hidden" },
    ilerlemeBar:  { height: "100%", borderRadius: "99px", transition: "width 0.8s ease" },
    sonucOzet:    { marginTop: "0.75rem", display: "flex", justifyContent: "space-between",
                    padding: "0.5rem 0.75rem", background: "#f0fdf4", borderRadius: "8px",
                    border: "1px solid", fontSize: "13px" },
    kesisimKart:  { background: C.panel, borderRadius: "12px", padding: "1.25rem",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)", border: "2px solid #2563eb", marginTop: "0.5rem" },
    kesisimBaslik:{ fontSize: "15px", fontWeight: "700", color: C.accent, marginBottom: "1rem" },
    hisseGrid:    { display: "flex", flexWrap: "wrap", gap: "0.5rem" },
    hisseEtiket:  { background: "#eff6ff", color: "#2563eb", fontWeight: "700", fontSize: "13px",
                    padding: "4px 12px", borderRadius: "6px", border: "1px solid #bfdbfe" },
    ckGrup:       { display: "flex", flexDirection: "column", gap: "4px", padding: "0.4rem 0.6rem",
                    border: "1px solid #d1d5db", borderRadius: "8px", background: C.panel, minWidth: "110px" },
    ckLabel:      { display: "flex", alignItems: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" },
};

const overlayStyle    = {position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000};
const modalStyle      = {background:C.panel,borderRadius:"14px",padding:"2rem",width:"480px",maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.25)"};
const modalBaslikStyle= {fontSize:"18px",fontWeight:"700",color:C.accent,marginBottom:"0.75rem"};
const btnVazgecStyle  = {padding:"8px 18px",borderRadius:"8px",border:"1px solid #d1d5db",background:C.panel,cursor:"pointer",fontSize:"13px",color:C.text};
const btnPrimaryStyle = {padding:"8px 20px",borderRadius:"8px",border:"none",background:C.accent,color:C.panel,cursor:"pointer",fontSize:"13px",fontWeight:"600"};
// ─── Mini Türkçe Takvim (Popup için) ──────────────────────────────────────────
const _TR_AYLAR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran",
                   "Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];

function MiniTakvim({ value, onChange }) {
    const bugun = new Date(); bugun.setHours(0,0,0,0);
    const [gorunenYil, setGorunenYil] = useState(bugun.getFullYear());
    const [gorunenAy,  setGorunenAy]  = useState(bugun.getMonth());
    const [yilMod,     setYilMod]     = useState(false);
    const [ayMod,      setAyMod]      = useState(false);

    const seciliTarih = value ? (() => { const d = new Date(value + "T00:00:00"); d.setHours(0,0,0,0); return d; })() : null;
    const baslangicGun = (new Date(gorunenYil, gorunenAy, 1).getDay() + 6) % 7;
    const gunSayisi    = new Date(gorunenYil, gorunenAy + 1, 0).getDate();
    const gunler = [];
    for (let i = 0; i < baslangicGun; i++) gunler.push(null);
    for (let d = 1; d <= gunSayisi; d++) gunler.push(d);

    const gunSec = gun => {
        if (!gun) return;
        const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
        if (t >= bugun) return;
        onChange(`${gorunenYil}-${String(gorunenAy+1).padStart(2,"0")}-${String(gun).padStart(2,"0")}`);
    };
    const oncekiAy = () => {
        if (gorunenAy === 0) { setGorunenYil(y => y-1); setGorunenAy(11); }
        else setGorunenAy(m => m-1);
    };
    const sonrakiAy = () => {
        const ny = gorunenAy === 11 ? 0 : gorunenAy+1;
        const fy = gorunenAy === 11 ? gorunenYil+1 : gorunenYil;
        if (new Date(fy, ny, 1) >= bugun) return;
        setGorunenAy(ny); setGorunenYil(fy);
    };
    const yillar = [];
    for (let y = bugun.getFullYear(); y >= 1990; y--) yillar.push(y);
    const sonrakiDevre = new Date(gorunenAy === 11 ? gorunenYil+1 : gorunenYil, gorunenAy === 11 ? 0 : gorunenAy+1, 1) >= bugun;

    return (
        <div style={{border:"1px solid #e5e7eb", borderRadius:"10px", padding:"12px", background:"#fafafa", userSelect:"none"}}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px"}}>
                <button type="button" onClick={oncekiAy} style={_navBtn}>&#8249;</button>
                <div style={{display:"flex", gap:"4px"}}>
                    <div style={{position:"relative"}}>
                        <button type="button" onClick={() => { setAyMod(v=>!v); setYilMod(false); }}
                            style={{fontWeight:"600", fontSize:"13px", color:C.accent,
                                    background: ayMod ? C.panel : "none",
                                    border: ayMod ? `1px solid ${C.border}` : "1px solid transparent",
                                    cursor:"pointer", padding:"2px 7px", borderRadius:"5px"}}>
                            {_TR_AYLAR[gorunenAy]} &#9662;
                        </button>
                        {ayMod && (
                            <div style={{position:"absolute", top:"calc(100% + 3px)", left:"50%",
                                         transform:"translateX(-50%)", zIndex:700, background:C.panel,
                                         borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.15)",
                                         border:`1px solid ${C.border}`, padding:"6px",
                                         display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"3px", minWidth:"175px"}}>
                                {_TR_AYLAR.map((ay, i) => {
                                    const dev = new Date(gorunenYil, i, 1) >= bugun;
                                    return (
                                        <button key={ay} type="button" disabled={dev}
                                            onClick={() => { setGorunenAy(i); setAyMod(false); }}
                                            style={{padding:"5px 3px", borderRadius:"5px", border:"none",
                                                    fontSize:"11px", cursor: dev ? "default" : "pointer",
                                                    background: i === gorunenAy ? C.accent : "transparent",
                                                    color: i === gorunenAy ? C.panel : dev ? "#475569" : C.text,
                                                    fontWeight: i === gorunenAy ? "600" : "400"}}>
                                            {ay.slice(0,3)}
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div style={{position:"relative"}}>
                        <button type="button" onClick={() => { setYilMod(v=>!v); setAyMod(false); }}
                            style={{fontWeight:"600", fontSize:"13px", color:C.accent,
                                    background: yilMod ? C.panel : "none",
                                    border: yilMod ? `1px solid ${C.border}` : "1px solid transparent",
                                    cursor:"pointer", padding:"2px 7px", borderRadius:"5px"}}>
                            {gorunenYil} &#9662;
                        </button>
                        {yilMod && (
                            <div style={{position:"absolute", top:"calc(100% + 3px)", left:"50%",
                                         transform:"translateX(-50%)", zIndex:700, background:C.panel,
                                         borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.15)",
                                         border:`1px solid ${C.border}`, maxHeight:"160px", color:C.text, overflowY:"auto", minWidth:"75px"}}>
                                {yillar.map(y => (
                                    <button key={y} type="button" onClick={() => { setGorunenYil(y); setYilMod(false); }}
                                        style={{display:"block", width:"100%", padding:"5px 12px", border:"none",
                                                textAlign:"center", fontSize:"12px", cursor:"pointer",
                                                background: y === gorunenYil ? C.accent : "transparent",
                                                color: y === gorunenYil ? C.panel : C.text,
                                                fontWeight: y === gorunenYil ? "600" : "400"}}>
                                        {y}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <button type="button" onClick={sonrakiAy}
                    style={{..._navBtn, opacity: sonrakiDevre ? 0.3 : 1, cursor: sonrakiDevre ? "default" : "pointer"}}>&#8250;</button>
            </div>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"1px", marginBottom:"3px"}}>
                {["Pt","Sa","Ça","Pe","Cu","Ct","Pz"].map(g => (
                    <div key={g} style={{textAlign:"center", fontSize:"10px", color:C.muted, fontWeight:"600", padding:"2px"}}>{g}</div>
                ))}
            </div>
            <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"1px"}}>
                {gunler.map((gun, i) => {
                    if (!gun) return <div key={"e"+i} />;
                    const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
                    const gelecek = t >= bugun;
                    const secili  = seciliTarih && t.getTime() === seciliTarih.getTime();
                    const bugunku = t.getTime() === bugun.getTime();
                    return (
                        <button key={gun} type="button" onClick={() => gunSec(gun)} disabled={gelecek}
                            style={{padding:"4px 2px", border:"none", borderRadius:"5px",
                                    fontSize:"11px", cursor: gelecek ? "default" : "pointer",
                                    background: secili ? C.accent : bugunku ? C.panel : "transparent",
                                    color: secili ? C.panel : gelecek ? "#475569" : bugunku ? C.accent : C.text,
                                    fontWeight: secili || bugunku ? "700" : "400"}}>
                            {gun}
                        </button>
                    );
                })}
            </div>
            <div style={{borderTop:`1px solid ${C.border}`, marginTop:"8px", paddingTop:"7px",
                         display:"flex", gap:"4px", flexWrap:"wrap"}}>
                {[["1 Ay",1],["3 Ay",3],["6 Ay",6],["1 Yıl",12],["2 Yıl",24],["3 Yıl",36]].map(([label, ay]) => (
                    <button key={label} type="button" onClick={() => {
                        const d = new Date(bugun); d.setMonth(d.getMonth() - ay);
                        const iso = d.toISOString().split("T")[0];
                        onChange(iso); setGorunenYil(d.getFullYear()); setGorunenAy(d.getMonth());
                    }} style={{padding:"2px 8px", borderRadius:"10px", fontSize:"10px",
                               border:`1px solid ${C.border}`, background:C.panel, cursor:"pointer", color:C.text}}>
                        {label}
                    </button>
                ))}
            </div>
            {value && (
                <div style={{textAlign:"center", marginTop:"8px", paddingTop:"7px",
                             borderTop:`1px solid ${C.border}`, fontSize:"12px", color:C.accent, fontWeight:"600"}}>
                    {(() => { const d = new Date(value + "T00:00:00");
                        return String(d.getDate()).padStart(2,"0") + " " + _TR_AYLAR[d.getMonth()] + " " + d.getFullYear(); })()}
                </div>
            )}
        </div>
    );
}
const _navBtn = {padding:"3px 9px", border:`1px solid ${C.border}`, borderRadius:"5px",
                 background:C.panel, cursor:"pointer", fontSize:"15px", color:C.text, lineHeight:"1"};


